import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { NgxEchartsDirective, provideEcharts } from 'ngx-echarts';
import { EChartsOption } from 'echarts/types/dist/echarts';
import { DashboardService } from '../../services/dashboard.service';
import { StrategyService } from '../../services/strategy.service';
import { Observable, skip, switchMap, tap } from 'rxjs';
import { Strategy } from '../../interfaces/models/strategy.model';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { Goal } from '../../interfaces/models/goal.model';
import { Indicator } from '../../interfaces/models/indicator.model';
import { IProject } from '../../interfaces/models/project.model';
import { NgApexchartsModule } from "ng-apexcharts";
import { chartColors } from '../../static-data/chart.config';
import { CountUpDirective } from '../../directives/count-up.directive';
import * as echarts from 'echarts';
import { SocketService } from '../../services/socket.service';
import { DialogModule } from 'primeng/dialog';
import { DashboardCards, IDashboardCard, PerformanceCardsNamesEnum } from '../../interfaces/models/performance..model';
import { TagModule } from 'primeng/tag';
import { CommonModule } from '@angular/common';
import { PerformanceCardComponent } from '../../shared/performance-card/performance-card.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { __metadata } from 'tslib';
import { ChartsService } from '../../services/charts.service';
import { DirectionService } from '../../services/direction.service';
import { RadioButtonModule } from 'primeng/radiobutton';
import { GoalsComponent } from '../../shared/components/goals/goals.component';
import { SharedProjectComponent } from '../../shared/components/shared-project/shared-project.component';
import { SharedIndicatorComponent } from '../../shared/components/shared-indicator/shared-indicator.component';
import { SidebarExpanderService } from '../../services/sidebar-expander.service';
import { ProjectService } from '../../services/project.service';
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports:
    [
      CommonModule,
      ButtonModule,
      DropdownModule,
      CountUpDirective,
      RouterModule,
      NgxEchartsDirective,
      NgApexchartsModule,
      FormsModule,
      DialogModule,
      TagModule,
      PerformanceCardComponent,
      TranslateModule,
      RadioButtonModule,
      GoalsComponent,
      SharedProjectComponent,
      SharedIndicatorComponent
    ],
  templateUrl: './dashboard.component.html',
  providers: [provideEcharts(),],
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit, OnDestroy {

  labelOption = {
    show: true,
    rotate: 90,
    formatter: '{c}  {name|{a}}',
    fontSize: 16,
    rich: {
      name: {}
    }
  };

  testoption !: EChartsOption;

  selectedStrategyId = 0;
  dashBoardData = {} as any;
  goals = [] as Goal[]
  indicators = [] as Indicator[]
  projects = [] as IProject[]
  strategyOptions = [] as { name: string, strategyId: number }[];
  projectsStatusChart!: any;
  bar_option!: EChartsOption;
  projectsPerDepartmentChart: any;
  pie_options!: EChartsOption;
  chartOptions !: any;
  chartMarkerOptions !: any;
  chartIndicatorOptions = [] as any[];
  myChart: any;
  dir!: 'rtl' | 'ltr';
  chartType = 'column-due'
  modalHeaderName = ""
  visible = false;
  selectedModalType = ''
  hoverIndicatorId = 0;
  
  // Chart modal properties
  chartModalVisible = false;
  chartModalTitle = '';
  chartModalOptions: any = null;
  customLegendItems!: string[];
  hoveredProjectId = 0;
  summaryCards = {} as any;
  indicatorWeightsOptions = {} as any;
  performnceCards = [
    ...DashboardCards.slice(0, 3).map((card) => {
      return {
        id: card.id,
        icon: card.icon,
        name: this.dir == 'ltr' ? card.enName : card.arName,
        count: card.count
      }
    })
  ] as IDashboardCard[];

  dashBoardCards = [
    {
      id: PerformanceCardsNamesEnum.goals,
      name: "الأهداف",
      icon: "fa-solid fa-bullseye f-right",
      count: this.goals.length
    },
    {
      id: PerformanceCardsNamesEnum.indicators,
      name: "المؤشرات",
      icon: "fa-solid fa-chart-line f-right",
      count: this.indicators.length
    },
    {
      id: PerformanceCardsNamesEnum.projects,
      name: "المبادرات",
      icon: "fa-solid fa-rocket f-right",
      count: this.projects.length
    },
  ] as {
    id: PerformanceCardsNamesEnum,
    name: string,
    count: number,
    icon: string
  }[];
  OverallProgressGaugeOptions = {} as any
  StrategicGoalsCoverageGaugeOptions = {} as any
  IndicatorClassificationChartOptions = {} as any
  progressTrendChartOptions = {} as any
  goalsCoverageChartOptions = {} as any
  goalsCoverageSemiCircleOptions = {} as any
  goalsCoverageData = { covered: 0, uncovered: 0, total: 0, percentage: 0 }
  topIndicatorsPieOptions = {} as any
  strategyYears = [] as {}[];
  
  // Tab Management
  activeTab = 'overview';
  dashboardTabs = [
    { 
      id: 'overview', 
      label: this.dir === 'rtl' ? 'نظرة عامة' : 'Overview',
      icon: 'fa-solid fa-chart-line'
    },
    { 
      id: 'departments', 
      label: this.dir === 'rtl' ? 'أداء الإدارات' : 'Department Performance',
      icon: 'fa-solid fa-building'
    },
    { 
      id: 'projects', 
      label: this.dir === 'rtl' ? 'المشاريع الاستراتيجية' : 'Strategic Projects',
      icon: 'fa-solid fa-rocket'
    },
    { 
      id: 'impact', 
      label: this.dir === 'rtl' ? 'الأثر والتنافسية' : 'Impact & Competitiveness',
      icon: 'fa-solid fa-trophy'
    }
  ];
  
  // Tab-specific chart options
  departmentTrendChartOptions = {} as any;
  departmentWorkloadChartOptions = {} as any;
  projectTimelineChartOptions = {} as any;
  projectBudgetChartOptions = {} as any;
  projectFunnelChartOptions = {} as any;
  riskChartOptions = {} as any;
  riskMitigationChartOptions = {} as any;
  impactTrendChartOptions = {} as any;
  competitiveChartOptions = {} as any;
  goalsAchievementChartOptions = {} as any;
  indicatorsProgressChartOptions = {} as any;
  indicatorDistributionChartOptions = {} as any;
  pillarCoverageChartOptions = {} as any;
  
  // KPI Data for each tab
  departmentKPIs = [] as any[];
  projectKPIs = [] as any[];
  impactKPIs = [] as any[];
  environmentalKPIs = [] as any[];
  departmentProjectsYear: { id: string | number, name: string } = {
    id: 'all',
    name: ""
  };

  goalWeightsOptions = {} as any;
  filteredProjectsYears = [] as {}[];
  filteredProjectsYear: { id: string | number, name: string } = {
    id: 'all',
    name: ""
  };

  // Additional properties for new dashboard design
  progressDelta = '5%';
  coverageRisk = 'Medium';


  constructor(
    private strategyService: StrategyService,
    private dashboardService: DashboardService,
    private socketService: SocketService,
    private chartsService: ChartsService,
    private directionService: DirectionService,
    private sidebarExpanderService: SidebarExpanderService,
    private translateService: TranslateService,
    private projectService: ProjectService,
    private cdr: ChangeDetectorRef
  ) {
    // Initialize dir with default value
    this.dir = document.dir === 'rtl' ? 'rtl' : 'ltr';
  }

  ngOnInit(): void {
    // Open sidebar on dashboard page load
    this.sidebarExpanderService.setDynamic(false);

    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
      this.setLocale();
      this.setYears(this.strategyYears);
      this.updateTabLabels();
      // Regenerate department chart when language changes ONLY if it exists
      if (this.chartOptions?.series) {
        this.setDepartmentsProjectsPerYearChart();
      }
      // Regenerate department trend chart with new language
      if (this.departments && this.departments.length > 0) {
        this.generateDepartmentTrendChart();
      }
    });

    this.strategyService.RawStrategies$.subscribe((strategies: Strategy[]) => {
      this.strategyOptions = strategies.map((x) => ({ name: x.name, strategyId: x.id }))
    });

    // Initialize all tabs data
    this.updateTabLabels();
    this.initializeAllTabsData();
    
    // Initialize department chart with default data immediately
    this.setDepartmentsProjectsPerYearChart();

    this.strategyService.defaultStrategy$.pipe(switchMap((strategy: any) => {
      this.selectedStrategyId = strategy.id;
      return this.dashboardService.getPerformancOwnerview(strategy.id);
    })).subscribe((response: any) => {
      this.handleResponse(response);
    });


    this.strategyService.selectedStrategy$.pipe(skip(1),



      switchMap((strategy: any) => {
        this.selectedStrategyId = strategy.id || 0;
        return this.dashboardService.getPerformancOwnerview(strategy.id || 0);
      })).subscribe((response: any) => {


        this.handleResponse(response);



      })



  };

  handleResponse(response: any) {
    console.log('🔍 Full API Response:', response);
    console.log('🔍 Response Data:', response?.['data']);
    console.log('🔍 Goals:', response?.['data']?.['goals']);
    console.log('🔍 Indicators:', response?.['data']?.['indicators']);
    console.log('🔍 Projects:', response?.['data']?.['projects']);

    this.goals = response?.['data']?.['goals'] || []
    this.indicators = response?.['data']?.['indicators'] || []
    // ownerview does not include projects; fallback to top strategic project if available
    this.projects = response?.['data']?.['projects'] || []
    if (!this.projects?.length && this.topStrategicHighlights?.project) {
      this.projects = [this.topStrategicHighlights.project];
    }
    try {
      console.log('ownerview keys', Object.keys(response?.['data'] || {}));
      console.log('projects length', this.projects?.length || 0);
    } catch { }
    this.projectsPerDepartmentChart = response?.['data']?.['projectsPerDepartmentChart'] || { names: [], data: {} };
    this.projectsStatusChart = response?.['data']?.['projectsStatusChart'] || { names: { ar: [], en: [] }, data: {} }

    // LOG API DATA FOR DEBUGGING
    console.log('📊 API projectsPerDepartmentChart:', this.projectsPerDepartmentChart);
    console.log('📊 Has names?', this.projectsPerDepartmentChart?.names?.length);
    console.log('📊 Has data?', Object.keys(this.projectsPerDepartmentChart?.data || {}).length);
    console.log('📊 API projectsStatusChart:', this.projectsStatusChart);
    console.log('📊 Status chart data keys:', Object.keys(this.projectsStatusChart?.data || {}));

    this.strategyYears = response['data']["years"] || [] as number[];
    this.setYears(this.strategyYears);
    
    // Update department chart with API data
    this.setDepartmentsProjectsPerYearChart();

    const localeKey = this.dir == 'ltr' ? "enName" : "arName";
    this.performnceCards = [
      {
        id: PerformanceCardsNamesEnum.goals,
        name: DashboardCards[0][localeKey],
        icon: "fa-solid fa-bullseye f-right",
        count: this.goals.length
      },
      {
        id: PerformanceCardsNamesEnum.indicators,
        name: DashboardCards[1][localeKey],
        icon: "fa-solid fa-chart-line f-right",
        count: this.indicators.length
      },
      {
        id: PerformanceCardsNamesEnum.projects,
        name: DashboardCards[2][localeKey],
        icon: "fa-solid fa-rocket f-right",
        count: this.projects.length
      },
    ]
    this.chartIndicatorOptions = [];
    const mostPerformingIndicators = response?.['data']?.['mostPerformingIndicators'] || [];
    mostPerformingIndicators.map((indicator: any) => {
      const pieChartOptions = this.createPieChartForIndicator(indicator);
      this.chartIndicatorOptions.push(pieChartOptions)
    });

    // Update project status chart with API data
    this.setfilteredProjectsPerYearChart();
    console.log('📊 Project status chart updated with API data');
    
    // FORCE generate ALL charts to match the image EXACTLY - NO API OVERRIDE
    this.generateProgressTrendChart();
    this.generateTopIndicatorsPieChart();
    this.generateIndicatorWeightsChart();
    this.generateIndicatorPerformanceDonutChart();
    // DON'T call setDepartmentsProjectsPerYearChart here - keep initial sample data

    this.dashboardService.getOverallProgressGaugeOptions(this.selectedStrategyId).subscribe((options: any) => {
      this.OverallProgressGaugeOptions = this.normalizeEchartColors(options);
    })
    this.dashboardService.getStrategicGoalsCoverageGaugeOptions(this.selectedStrategyId).subscribe((options: any) => {
      this.StrategicGoalsCoverageGaugeOptions = this.normalizeEchartColors(options);
    })

    // OVERRIDE with image-matching donut chart
    this.generateIndicatorPerformanceDonutChart();

    this.loadTop5Departments(this.selectedStrategyId);
    this.dashboardService.getStrategyDashboardSummary(this.selectedStrategyId).subscribe({
      next: (response: any) => {
        this.summaryCards = response;
        this.applyDepartmentSummary(response);
      },
      error: (err) => {
        console.error("❌ API Error:", err);
      }
    })

    // OVERRIDE with image-matching charts - ignore API data for now
    this.generateIndicatorWeightsChart();
    this.getTopStrategicHighlights(this.selectedStrategyId);



  };

  strategyOptionsChange() {

    this.strategyService.setStrategyIdfn(this.selectedStrategyId);

    this.socketService.setRefreshNotification(this.selectedStrategyId);
    
    // Reload top 5 departments to update trend chart
    this.loadTop5Departments(this.selectedStrategyId);
    
    // Reload summary data to update KPIs
    this.dashboardService.getStrategyDashboardSummary(this.selectedStrategyId).subscribe({
      next: (response: any) => {
        this.summaryCards = response;
        this.applyDepartmentSummary(response);
      },
      error: (err) => console.error("❌ Strategy Change Error:", err)
    });
  }



  isModalVisable(performanceCardsNamesEnum: PerformanceCardsNamesEnum) {
    this.selectedModalType = performanceCardsNamesEnum;
    const localeKey = this.dir == 'ltr' ? "enName" : "arName";
    switch (performanceCardsNamesEnum) {
      case PerformanceCardsNamesEnum.goals:
        this.modalHeaderName = DashboardCards[0][localeKey]
        break;
      case PerformanceCardsNamesEnum.indicators:
        this.modalHeaderName = DashboardCards[1][localeKey]
        break;
      case PerformanceCardsNamesEnum.projects:
        this.modalHeaderName = DashboardCards[2][localeKey]
        break;

      default:
        this.modalHeaderName = '';
        break;
    }
    this.visible = true;
  };
  onMouseEnter(hoverIndicatorId: number) {
    this.hoverIndicatorId = hoverIndicatorId;
  };

  onMouseLeave() {
    this.hoverIndicatorId = 0;
  };

  onProjectMouseEnter(hoveredProjectId: number) {
    this.hoveredProjectId = hoveredProjectId;
  };

  onProjectMouseLeave() {
    this.hoveredProjectId = 0;
  };

  setCustomLegendItems() {
    this.customLegendItems = this.dir == 'rtl' ?
      structuredClone(["المستهدف", "محقق بشكل ايجابي", "محقق بشكل سلبي"]) :
      structuredClone(["Target", "Positive Actual", "Negative Actual"])
    return this.customLegendItems;
  };
  setfilteredProjectsPerYearChart() {
    const yearId = this.filteredProjectsYear?.id as any;
    
    // Get data from API - use actual data structure
    let seriesSource: any[] = (((this.projectsStatusChart?.['data']) || {}) as any)[yearId] || [];
    let statusNames = (this.projectsStatusChart?.['names']?.[this.dir == "rtl" ? "ar" : "en"] || []);
    
    console.log('📊 DEBUGGING Project Status Chart:');
    console.log('📊 Selected Year ID:', yearId);
    console.log('📊 Full projectsStatusChart:', this.projectsStatusChart);
    console.log('📊 Available year keys:', Object.keys(this.projectsStatusChart?.['data'] || {}));
    console.log('📊 Series data for year:', seriesSource);
    console.log('📊 Series data VALUES:', JSON.stringify(seriesSource));
    console.log('📊 Series data TYPE:', typeof seriesSource);
    console.log('📊 Series data LENGTH:', seriesSource?.length);
    console.log('📊 Series data ITEMS:', seriesSource?.map((item: any, index: number) => `[${index}]: ${item} (${typeof item})`));
    console.log('📊 Status names:', statusNames);
    console.log('📊 Status names VALUES:', JSON.stringify(statusNames));
    console.log('📊 Status names LENGTH:', statusNames?.length);
    console.log('📊 Status names ITEMS:', statusNames?.map((item: string, index: number) => `[${index}]: "${item}" (${typeof item})`));
    console.log('📊 Projects array from API:', this.projects);
    console.log('📊 Number of projects:', this.projects?.length);
    
    // FALLBACK: If projectsStatusChart is empty, calculate from projects array
    if (seriesSource.length === 0 && this.projects && this.projects.length > 0) {
      console.log('📊 Using projects array to generate status distribution');
      
      // Count projects by status
      const statusCounts: any = {};
      const statusLabels: any = {
        ar: [],
        en: []
      };
      
      this.projects.forEach((project: any) => {
        const status = project.assessment_status || 'draft';
        const statusName = project.assessment_status_name || status;
        
        if (!statusCounts[status]) {
          statusCounts[status] = 0;
          // Use the status name from API or default based on status
          const defaultNames: any = {
            'draft': { ar: 'مسودة', en: 'Draft' },
            'pending': { ar: 'قيد المراجعة', en: 'Pending' },
            'approved': { ar: 'معتمدة', en: 'Approved' },
            'rejected': { ar: 'مرفوضة', en: 'Rejected' }
          };
          statusLabels.ar.push(statusName || defaultNames[status]?.ar || 'غير محدد');
          statusLabels.en.push(statusName || defaultNames[status]?.en || 'Unknown');
        }
        statusCounts[status]++;
      });
      
      seriesSource = Object.values(statusCounts);
      statusNames = statusLabels[this.dir === 'rtl' ? 'ar' : 'en'];
      
      console.log('📊 Calculated status counts:', statusCounts);
      console.log('📊 Calculated status names:', statusNames);
      console.log('📊 Calculated series:', seriesSource);
    }
    
    // New design colors
    const designColors = ['#C91F3B', '#E0455C', '#A71932', '#F07080', '#10b981', '#f59e0b', '#ef4444'];
    
    // CHANGED: Use vertical bar chart instead of donut for better visibility of all projects
    this.pie_options = {
      animation: true,
      animationDuration: 2000,
      animationEasing: 'elasticOut',
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        formatter: (params: any) => {
          const item = params[0];
          const total = seriesSource.reduce((sum: number, val: number) => sum + val, 0);
          const percentage = total > 0 ? ((item.value / total) * 100).toFixed(1) : 0;
          return `<div style="font-family: Cairo; padding: 8px;">
            <strong>${item.name}</strong><br/>
            ${this.dir === 'rtl' ? 'العدد' : 'Count'}: <strong>${item.value}</strong><br/>
            ${this.dir === 'rtl' ? 'النسبة' : 'Percentage'}: <strong>${percentage}%</strong>
          </div>`;
        },
        backgroundColor: '#ffffff',
        borderColor: '#C91F3B',
        borderWidth: 1,
        textStyle: {
          fontWeight: 'bold',
          fontSize: 12,
          fontFamily: 'Cairo',
          color: '#333'
        }
      },
      legend: {
        show: false
      },
      grid: {
        left: '8%',
        right: '5%',
        bottom: '15%',
        top: '8%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: statusNames,
        axisLabel: {
          fontSize: 10,
          fontFamily: 'Cairo',
          color: '#374151',
          interval: 0,
          rotate: 20,
          formatter: (value: string) => {
            return value.length > 12 ? value.substring(0, 12) + '..' : value;
          }
        },
        axisTick: { show: false },
        axisLine: { lineStyle: { color: '#e5e7eb' } }
      },
      yAxis: {
        type: 'value',
        minInterval: 1,
        axisLabel: {
          fontSize: 11,
          fontFamily: 'Cairo',
          color: '#666'
        },
        splitLine: {
          show: true,
          lineStyle: { type: 'dashed', color: '#e5e7eb' }
        },
        axisTick: { show: false },
        axisLine: { show: false }
      },
      series: [
        {
          name: this.dir === 'rtl' ? 'عدد المبادرات' : 'Project Count',
          type: 'bar',
          barWidth: '50%',
          itemStyle: {
            borderRadius: [8, 8, 0, 0]
          },
          label: {
            show: true,
            position: 'top',
            formatter: '{c}',
            fontSize: 11,
            fontWeight: 'bold',
            color: '#374151',
            fontFamily: 'Cairo'
          },
          data: seriesSource.map((value: number, index: number) => ({
            value,
            itemStyle: { color: designColors[index % designColors.length] }
          })),
          // Bars rise from bottom with bounce
          animationDuration: 1800,
          animationEasing: 'elasticOut',
          animationDelay: (idx: number) => idx * 150
        }
      ]
    } as any;
    
    // DEBUG: Log final chart configuration
    console.log('📊 Final pie_options chart data:', (this.pie_options.series as any)?.[0]?.data);
    console.log('📊 Final pie_options xAxis data:', (this.pie_options.xAxis as any)?.data);
    console.log('📊 Final pie_options series length:', (this.pie_options.series as any)?.[0]?.data?.length);
    
    // Check if data is valid
    const chartData = (this.pie_options.series as any)?.[0]?.data;
    const xAxisData = (this.pie_options.xAxis as any)?.data;
    console.log('📊 Chart data validation:');
    console.log('📊 - Chart data exists:', !!chartData);
    console.log('📊 - Chart data length:', chartData?.length);
    console.log('📊 - X-axis data exists:', !!xAxisData);
    console.log('📊 - X-axis data length:', xAxisData?.length);
    console.log('📊 - All data points valid:', chartData?.every((item: any) => typeof item.value === 'number' && item.value > 0));
    
    // Force chart update by creating new object reference
    this.pie_options = { ...this.pie_options };
  };
  setDepartmentsProjectsPerYearChart() {
    const names = this.projectsPerDepartmentChart?.['names'] || [];
    const data = ((this.projectsPerDepartmentChart?.['data'] || {}) as any)[this.departmentProjectsYear?.id as any] || [];
    
    // Use API data if available, otherwise use sample fallback
    let chartNames = names;
    let chartData = data;
    
    // Fallback to sample data only if API data is empty
    if (!chartNames || chartNames.length === 0) {
      chartNames = this.dir === 'rtl' ? [
        'إدارة الخدمات',
        'إدارة التنوع البيولوجي',
        'مكتب الاستراتيجية',
        'مكتب الاتصال المؤسسي',
        'المدير العام',
        'الشؤون الإدارية',
        'إدارة المعلومات',
        'إدارة الجودة',
        'إدارة البحوث'
      ] : [
        'Services Department',
        'Biodiversity Department',
        'Strategy Office',
        'Corporate Communication Office',
        'Director General',
        'Administrative Affairs',
        'Information Department',
        'Quality Department',
        'Research Department'
      ];
      chartData = [75, 84, 40, 35, 40, 75, 61, 40, 68];
    }
    
    // New design colors
    const palette = ['#C91F3B', '#E0455C', '#A71932', '#F07080', '#A71932'];
    
    const coloredData = (chartData || []).map((value: number, index: number) => ({
      value,
      itemStyle: { 
        color: palette[index % palette.length],
        // Rounded on the LEFT side for RTL, RIGHT side for LTR (opposite of before)
        borderRadius: this.dir === 'rtl' ? [0, 8, 8, 0] : [8, 0, 0, 8]
      },
      emphasis: { 
        itemStyle: { 
          color: '#A71932',
          shadowBlur: 10,
          shadowColor: 'rgba(201, 31, 59, 0.5)'
        } 
      }
    }));
    
    this.chartOptions = {
      animation: true,
      animationDuration: 2000,
      animationEasing: 'elasticOut',
      animationThreshold: 1000,
      grid: {
        left: '8%',
        right: '5%',
        bottom: '18%',
        top: '5%',
        containLabel: true
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        formatter: (params: any) => {
          const item = params[0];
          const fullName = item.name;
          return `<div style="font-family: Cairo; padding: 8px;">
            <strong>${fullName}</strong><br/>
            ${this.dir == 'rtl' ? 'عدد المبادرات' : 'Number of Initiatives'}: <strong>${item.value}</strong>
          </div>`;
        },
        backgroundColor: '#ffffff',
        borderColor: '#C91F3B',
        borderWidth: 1,
        textStyle: {
          fontWeight: 'bold',
          fontSize: 12,
          fontFamily: 'Cairo',
          color: '#333'
        },
        confine: true,
        extraCssText: 'max-width: 300px; white-space: normal; word-wrap: break-word;'
      },
      xAxis: {
        type: 'category',
        data: chartNames,
        axisLabel: {
          fontWeight: '500',
          fontSize: 9,
          fontFamily: 'Cairo',
          color: '#374151',
          interval: 0,
          rotate: 30,
          formatter: (value: string) => {
            return value.length > 10 ? value.substring(0, 10) + '..' : value;
          }
        },
        axisTick: { show: false },
        axisLine: { lineStyle: { color: '#e5e7eb' } }
      },
      yAxis: {
        type: 'value',
        minInterval: 1,
        splitLine: {
          show: true,
          lineStyle: { type: 'dashed', color: '#e5e7eb' }
        },
        axisLabel: {
          fontSize: 11,
          fontFamily: 'Cairo',
          color: '#666'
        },
        axisTick: { show: false },
        axisLine: { show: false }
      },
      series: [
        {
          name: this.dir === 'rtl' ? 'عدد المبادرات' : 'Initiatives Count',
          type: 'bar',
          barWidth: '45%',
          showBackground: false,
          itemStyle: {
            borderRadius: [8, 8, 0, 0]
          },
          label: {
            show: true,
            position: 'top',
            formatter: '{c}',
            fontSize: 11,
            fontWeight: 'bold' as any,
            color: '#374151',
            fontFamily: 'Cairo'
          } as any,
          data: chartData.map((value: number, index: number) => ({
            value,
            itemStyle: { 
              color: palette[index % palette.length]
            }
          })),
          // Bars rise from bottom with bounce
          animationDuration: 1800,
          animationEasing: 'elasticOut',
          animationDelay: (idx: number) => idx * 100
        }
      ]
    } as any;
    

    
    // Force chart update by creating new object reference
    this.chartOptions = { ...this.chartOptions };
  };

  setYears(resYears: {}[]) {
    this.strategyYears = [
      ...resYears.map((year: any) => {
        return {
          name: typeof year == "object" ? year.name : year,
          id: typeof year == "object" ? year.id : year,
        }
      })
    ];
    if (this.strategyYears.find((year: any) => year.id == "all")) this.strategyYears.shift();
    this.strategyYears.unshift(
      {
        name: this.dir == "ltr" ? "All Years" : "كل الأعوام",
        id: "all"
      }
    );
    if (this.departmentProjectsYear.id == "all") this.departmentProjectsYear = this.strategyYears.find((year: any) => year.id == "all") as any;
    if (this.filteredProjectsYear.id == "all") this.filteredProjectsYear = this.strategyYears.find((year: any) => year.id == "all") as any;
  };

  departmentProjectsYearChange() {
    this.setDepartmentsProjectsPerYearChart()
  }

  filteredProjectsYearChange() {
    console.log('📊 Year filter changed to:', this.filteredProjectsYear);
    this.setfilteredProjectsPerYearChart();
  };

  setLocale() {
    this.performnceCards = structuredClone(this.performnceCards.map((card, index) => {
      return {
        ...card,
        name: DashboardCards[index][this.dir == 'ltr' ? "enName" : "arName"]
      }
    }))
  };

  departments = [] as any[];
  departmentPerformanceChartOptions = {} as any;

  getDepartmentBubbleChartOptions(data: any[]): any {
    return {
      tooltip: {
        trigger: 'item',
        formatter: (params: any) => {
          return `
            <strong>${params.value[2]}</strong><br/>
            التقدم: ${params.value[0]}%<br/>
            عدد المبادرات: ${params.value[1]}
          `;
        }
      },
      xAxis: {
        name: 'متوسط التقدم (%)',
        nameLocation: 'middle',
        nameGap: 30,
        axisLabel: {
          formatter: '{value}%',
        }
      },
      yAxis: {
        type: 'category',
        data: data.map(d => d.departmentName),
        name: 'الإدارة',
        nameLocation: 'middle',
        nameGap: 50
      },
      series: [
        {
          type: 'scatter',
          symbolSize: (value: any[]) => Math.max(10, value[1] * 2), // scale size based on number of projects
          data: data.map(d => [d.averageProgress, d.totalProjects, d.departmentName]),
          itemStyle: {
            color: '#007bff',
            opacity: 0.8
          },
          label: {
            show: true,
            formatter: (param: any) => `${param.value[0]}%`,
            position: 'right',
            fontSize: 12
          }
        }
      ]
    };
  }
  departmentPerformanceShowTable = false;
  loadTop5Departments(strategyId: number) {
    this.dashboardService.getTop5DepartmentsPerformance(strategyId).subscribe({
      next: (data) => {
        console.log('📊 Top 5 Departments from API:', data);
        this.departments = data || [];
        this.departmentPerformanceChartOptions = this.getDepartmentPerformanceBarChartOptions(this.departments);
        
        // Regenerate department trend chart with top 3 departments
        // This will use sample data if departments is empty
        this.generateDepartmentTrendChart();
        // Regenerate workload chart with all departments
        this.generateDepartmentWorkloadChart();
        
        console.log('✅ Department charts regenerated');
      },
      error: (error) => {
        console.error('❌ Error loading departments:', error);
        // Even on error, generate charts with sample data
        this.departments = [];
        this.generateDepartmentTrendChart();
        this.generateDepartmentWorkloadChart();
      }
    });
  }

  getDepartmentPerformanceBarChartOptions(data: any[]): any {
    // Use API data directly - NO sample fallback
    const departmentNames = data && data.length > 0 
      ? data.map(d => d.departmentName) 
      : [];
    const departmentProgress = data && data.length > 0 
      ? data.map(d => d.averageProgress) 
      : [];
    
    return {
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        formatter: (params: any) => {
          const item = params[0];
          const fullDeptName = item.name;
          const avg = item.value;
          const total = data?.find((d: any) => d.departmentName === fullDeptName)?.totalProjects || 0;
          return `<div style="font-family: Cairo; padding: 8px;">
            <strong>${fullDeptName}</strong><br/>
            ${this.dir === 'rtl' ? 'متوسط الإنجاز' : 'Average Progress'}: <strong>${avg?.toFixed(1)}%</strong><br/>
            ${this.dir === 'rtl' ? 'عدد المشاريع' : 'Total Projects'}: <strong>${total}</strong>
          </div>`;
        },
        backgroundColor: '#ffffff',
        borderColor: '#C91F3B',
        borderWidth: 1,
        textStyle: {
          color: '#333',
          fontFamily: 'Cairo',
          fontWeight: 'bold',
          fontSize: 12
        },
        confine: true,
        extraCssText: 'max-width: 300px; white-space: normal; word-wrap: break-word;'
      },
      grid: {
        left: 150,
        right: 80,
        bottom: '5%',
        top: '5%',
        containLabel: false
      },
      xAxis: {
        type: 'value',
        max: 100,
        axisLabel: {
          formatter: '{value}%',
          fontSize: 11,
          fontFamily: 'Cairo',
          color: '#666'
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            color: '#e5e7eb'
          }
        }
      },
      yAxis: {
        type: 'category',
        data: departmentNames,
        axisLabel: {
          fontSize: 12,
          fontFamily: 'Cairo',
          color: '#374151',
          fontWeight: 500,
          margin: 15,
          width: 120,
          overflow: 'truncate',
          ellipsis: '...',
          formatter: (value: string) => {
            // Show only first 12 characters + ellipsis
            return value.length > 12 ? value.substring(0, 12) + '...' : value;
          }
        },
        triggerEvent: true // Enable hover events
      },
      series: [
        {
          name: this.dir === 'rtl' ? 'نسبة الإنجاز' : 'Completion Rate',
          type: 'bar',
          barWidth: '50%',
          data: departmentProgress,
          itemStyle: {
            color: '#C91F3B',
            borderRadius: this.dir === 'rtl' ? [8, 0, 0, 8] : [0, 8, 8, 0]
          },
          label: {
            show: true,
            position: this.dir === 'rtl' ? 'insideLeft' : 'insideRight',
            formatter: '{c}%',
            fontSize: 12,
            fontWeight: 'bold',
            color: '#ffffff',
            fontFamily: 'Cairo'
          },
          animationDuration: 1500,
          animationEasing: 'cubicOut'
        }
      ]
    };
  }

  topStrategicHighlights = {} as any;
  getTopStrategicHighlights(strategyId: number) {
    this.dashboardService.getTopStrategicHighlights(strategyId).subscribe({
      next: (data) => {
        this.topStrategicHighlights = data.data;
        console.log('🔍 Top Strategic Highlights:', this.topStrategicHighlights);
        console.log('🔍 Indicator Name:', this.topStrategicHighlights?.indicator?.name);
      }
    })
  }
  
  // Generate progress trend BAR chart - THIN BARS, COMPACT SIZE
  generateProgressTrendChart() {
    // Localized month names
    const months = this.dir === 'rtl' 
      ? ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
      : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    const progressData = [65, 45, 70, 40, 55, 60, 75, 90, 55, 40, 100, 50];
    const tealColor = '#C91F3B';
    
    this.progressTrendChartOptions = {
      animation: true,
      animationDuration: 2000,
      animationEasing: 'elasticOut',
      animationThreshold: 1000,
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        backgroundColor: '#ffffff',
        borderColor: tealColor,
        borderWidth: 1,
        textStyle: {
          color: '#333',
          fontFamily: 'Cairo',
          fontSize: 11
        },
        formatter: (params: any) => {
          const param = params[0];
          return `<div style="font-family: Cairo; padding: 4px;">
            <strong>${param.name}</strong><br/>
            ${param.value}%
          </div>`;
        }
      },
      grid: {
        left: '8%',
        right: '5%',
        bottom: '12%',
        top: '10%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: months,
        axisLabel: {
          fontFamily: 'Cairo',
          fontSize: 8,
          color: '#666',
          rotate: 0,
          interval: 0
        },
        axisLine: {
          show: true,
          lineStyle: { color: '#e5e7eb' }
        },
        axisTick: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        min: 0,
        max: 100,
        interval: 20,
        axisLabel: {
          formatter: '{value}%',
          fontFamily: 'Cairo',
          fontSize: 9,
          color: '#666'
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'solid',
            color: '#f5f5f5',
            width: 1
          }
        },
        axisLine: {
          show: false
        }
      },
      series: [
        {
          type: 'bar',
          data: progressData,
          barWidth: '28%',
          itemStyle: {
            color: tealColor,
            borderRadius: [3, 3, 0, 0]
          },
          emphasis: {
            itemStyle: {
              color: '#A71932',
              shadowBlur: 6,
              shadowColor: 'rgba(201, 31, 59, 0.4)'
            }
          },
          // Bars rise from bottom to top
          animationDuration: 1500,
          animationEasing: 'elasticOut',
          animationDelay: (idx: number) => idx * 80
        }
      ]
    };
  }
  
  // Generate indicator weights chart - ROUNDED TOP BARS
  generateIndicatorWeightsChart() {
    const categories = ['1', '2'];
    const barHeights = [5, 2.5]; // Visual height on the chart
    const labelValues = [0.98, 0.7]; // Values to display as labels
    
    this.indicatorWeightsOptions = {
      animation: true,
      animationDuration: 2000,
      animationEasing: 'elasticOut',
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        formatter: (params: any) => {
          const param = params[0];
          const labelValue = labelValues[param.dataIndex];
          return `<div style="font-family: Cairo; padding: 4px;">
            <strong>${this.dir === 'rtl' ? 'المؤشر' : 'Indicator'} ${param.name}</strong><br/>
            ${labelValue}%
          </div>`;
        },
        backgroundColor: '#ffffff',
        borderColor: '#C91F3B',
        borderWidth: 1,
        textStyle: {
          fontFamily: 'Cairo',
          fontSize: 11,
          color: '#333'
        }
      },
      grid: {
        left: '18%',
        right: '18%',
        bottom: '18%',
        top: '18%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: categories,
        axisLabel: {
          fontFamily: 'Cairo',
          fontSize: 11,
          color: '#666',
          fontWeight: '500'
        },
        axisLine: {
          show: true,
          lineStyle: { color: '#e5e7eb' }
        },
        axisTick: { show: false }
      },
      yAxis: {
        type: 'value',
        min: 0,
        max: 10,
        interval: 2,
        axisLabel: {
          formatter: '{value}%',
          fontFamily: 'Cairo',
          fontSize: 9,
          color: '#666'
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'solid',
            color: '#f5f5f5',
            width: 1
          }
        },
        axisLine: {
          show: false
        }
      },
      series: [
        {
          type: 'bar',
          data: barHeights,
          barWidth: '32%',
          itemStyle: {
            color: '#C91F3B',
            borderRadius: [50, 50, 0, 0]
          },
          label: {
            show: true,
            position: 'top',
            formatter: (params: any) => {
              return labelValues[params.dataIndex] + '%';
            },
            fontSize: 9,
            fontWeight: 'bold',
            fontFamily: 'Cairo',
            color: '#666'
          },
          emphasis: {
            itemStyle: {
              color: '#A71932',
              shadowBlur: 6,
              shadowColor: 'rgba(201, 31, 59, 0.4)'
            }
          },
          // Bars grow from bottom to top
          animationDuration: 1800,
          animationEasing: 'elasticOut',
          animationDelay: (idx: number) => idx * 200
        }
      ]
    };
  }
  
  // Generate top indicators semi-circular pie chart (matching image)
  generateTopIndicatorsPieChart() {
    // Sample data showing 4 segments as shown in image with exact percentages
    const tealColors = ['#A71932', '#C91F3B', '#E0455C', '#F07080'];
    
    const indicatorLabels = this.dir === 'rtl' 
      ? ['مؤشر أ', 'مؤشر ب', 'مؤشر ج', 'أخرى']
      : ['Indicator A', 'Indicator B', 'Indicator C', 'Other'];
    
    const data = [
      { value: 48.3, name: indicatorLabels[0], itemStyle: { color: tealColors[0] } },
      { value: 28.8, name: indicatorLabels[1], itemStyle: { color: tealColors[1] } },
      { value: 13.7, name: indicatorLabels[2], itemStyle: { color: tealColors[2] } },
      { value: 9.1, name: indicatorLabels[3], itemStyle: { color: tealColors[3] } }
    ];
    
    this.topIndicatorsPieOptions = {
      animation: true,
      animationDuration: 2500,
      animationEasing: 'cubicInOut',
      tooltip: {
        trigger: 'item',
        formatter: '{b}: {d}%',
        backgroundColor: '#ffffff',
        borderColor: '#C91F3B',
        borderWidth: 1,
        textStyle: {
          fontFamily: 'Cairo',
          fontSize: 12,
          color: '#333'
        }
      },
      legend: {
        orient: 'horizontal',
        bottom: '8%',
        left: 'center',
        textStyle: {
          fontFamily: 'Cairo',
          fontSize: 10,
          color: '#666'
        },
        itemGap: 15,
        itemWidth: 10,
        itemHeight: 10
      },
      series: [
        {
          type: 'pie',
          radius: ['45%', '75%'],
          center: ['50%', '45%'],
          startAngle: 180,
          endAngle: 360,
          data: data,
          label: {
            show: true,
            formatter: '{d}%',
            fontSize: 11,
            fontWeight: 'bold',
            fontFamily: 'Cairo',
            color: '#fff',
            position: 'inside'
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            borderRadius: 6,
            borderColor: '#fff',
            borderWidth: 2
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 12,
              shadowColor: 'rgba(201, 31, 59, 0.4)'
            },
            label: {
              show: true,
              fontSize: 13,
              fontWeight: 'bold'
            }
          },
          // Pie segments grow clockwise from start angle
          animationType: 'expansion',
          animationEasing: 'cubicInOut',
          animationDuration: 2000,
          animationDelay: (idx: number) => idx * 200
        }
      ]
    };
  }
  
  // Generate indicator performance donut chart (full circle matching image)
  generateIndicatorPerformanceDonutChart() {
    // Sample data showing approximately 70% performance
    const performancePercentage = 72;
    const tealColor = '#C91F3B';
    
    const performanceLabel = this.dir === 'rtl' ? 'الأداء' : 'Performance';
    const remainingLabel = this.dir === 'rtl' ? 'المتبقي' : 'Remaining';
    
    this.IndicatorClassificationChartOptions = {
      animation: true,
      animationDuration: 2500,
      animationEasing: 'cubicInOut',
      tooltip: {
        trigger: 'item',
        formatter: '{b}: {d}%',
        backgroundColor: '#ffffff',
        borderColor: tealColor,
        borderWidth: 1,
        textStyle: {
          fontFamily: 'Cairo',
          fontSize: 12,
          color: '#333'
        }
      },
      legend: {
        show: false
      },
      series: [
        {
          type: 'pie',
          radius: ['55%', '75%'],
          center: ['50%', '50%'],
          avoidLabelOverlap: true,
          clockwise: true,
          startAngle: 90,
          itemStyle: {
            borderRadius: 8,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            show: true,
            formatter: '{d}%',
            fontSize: 16,
            fontWeight: 'bold',
            fontFamily: 'Cairo',
            color: '#2d3748',
            position: 'outside',
            distanceToLabelLine: 5
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 18,
              fontWeight: 'bold'
            },
            itemStyle: {
              shadowBlur: 15,
              shadowColor: 'rgba(201, 31, 59, 0.5)'
            }
          },
          labelLine: {
            show: true,
            length: 15,
            length2: 10,
            smooth: false,
            lineStyle: {
              color: '#888888',
              width: 1.5
            }
          },
          data: [
            {
              value: performancePercentage,
              name: performanceLabel,
              itemStyle: { color: tealColor }
            },
            {
              value: 100 - performancePercentage,
              name: remainingLabel,
              itemStyle: { color: '#e5e7eb' }
            }
          ],
          // Donut fills clockwise like a progress circle
          animationType: 'expansion',
          animationEasing: 'cubicInOut',
          animationDuration: 2000
        }
      ]
    };
  }
  
  // Generate goals coverage semi-circle gauge chart
  generateGoalsCoverageChart() {
    // Sample data - in real scenario this would come from API
    const coveredGoals = this.goals.length > 0 ? this.goals.length : 12;
    const totalGoals = this.goals.length > 0 ? Math.ceil(this.goals.length * 1.3) : 15;
    const uncoveredGoals = totalGoals - coveredGoals;
    const percentage = Math.round((coveredGoals / totalGoals) * 100);
    
    // Store data for display
    this.goalsCoverageData = {
      covered: coveredGoals,
      uncovered: uncoveredGoals,
      total: totalGoals,
      percentage: percentage
    };
    
    this.goalsCoverageSemiCircleOptions = {
      series: [
        {
          type: 'gauge',
          startAngle: 180,
          endAngle: 0,
          center: ['50%', '85%'],
          radius: '110%',
          min: 0,
          max: 100,
          splitNumber: 5,
          axisLine: {
            lineStyle: {
              width: 18,
              color: [
                [percentage / 100, '#C91F3B'],
                [1, '#f3f4f6']
              ]
            }
          },
          pointer: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            show: false
          },
          detail: {
            valueAnimation: true,
            formatter: '{value}%',
            color: '#C91F3B',
            fontSize: 28,
            fontWeight: 'bold',
            fontFamily: 'Cairo',
            offsetCenter: [0, '-25%']
          },
          data: [
            {
              value: percentage
            }
          ],
          animationDuration: 2500,
          animationEasing: 'elasticOut'
        }
      ]
    };
  }
  
  // normalize incoming echarts options to unified palette matching new design
  private normalizeEchartColors(options: any): any {
    if (!options) return options;
    const cloned = JSON.parse(JSON.stringify(options));
    
    // New design color palette
    const designColors = {
      primary: '#C91F3B',
      primaryLight: '#E0455C',
      primaryLighter: '#A71932',
      primaryExtraLight: '#F07080',
      primaryUltraLight: '#d6eaed',
      primaryDark: '#A71932',
      primaryDarker: '#0f5761',
      green: '#10b981',
      yellow: '#f59e0b',
      red: '#ef4444',
      blue: '#C91F3B'
    };
    
    // top-level color palette (cycled by ECharts for series/data)
    cloned.color = [
      designColors.primary,
      designColors.primaryLight,
      designColors.primaryLighter,
      designColors.primaryExtraLight,
      designColors.primaryDark,
      designColors.green,
      designColors.yellow
    ];
    
    // Apply Cairo font family globally
    if (!cloned.textStyle) cloned.textStyle = {};
    cloned.textStyle.fontFamily = 'Cairo';
    
    // Hide title (we use H3 headers in the template instead)
    if (cloned.title) {
      cloned.title.show = false;
    }
    
    // Enhanced tooltip styling
    if (cloned.tooltip) {
      if (!cloned.tooltip.textStyle) cloned.tooltip.textStyle = {};
      cloned.tooltip.textStyle.fontFamily = 'Cairo';
      cloned.tooltip.backgroundColor = '#ffffff';
      cloned.tooltip.borderColor = designColors.primary;
      cloned.tooltip.borderWidth = 1;
    }
    
    // For pie charts, allow per-slice coloring with animations
    // For gauges and other types, apply primary color
    if (Array.isArray(cloned.series)) {
      cloned.series = cloned.series.map((s: any, seriesIdx: number) => {
        if (!s) return s;
        
        if (s.type === 'pie') {
          if (s.itemStyle && s.itemStyle.color) delete s.itemStyle.color;
          // Enhanced pie styling
          if (!s.itemStyle) s.itemStyle = {};
          s.itemStyle.borderRadius = 10;
          s.itemStyle.borderColor = '#fff';
          s.itemStyle.borderWidth = 3;
          
          // Better animations for pie
          s.animationType = 'scale';
          s.animationEasing = 'elasticOut';
          s.animationDuration = 1000;
          
          // Label styling
          if (!s.label) s.label = {};
          s.label.fontFamily = 'Cairo';
          s.label.fontWeight = 'bold';
          
          // Legend styling
          if (!s.emphasis) s.emphasis = {};
          if (!s.emphasis.itemStyle) s.emphasis.itemStyle = {};
          s.emphasis.itemStyle.shadowBlur = 15;
          s.emphasis.itemStyle.shadowColor = 'rgba(97, 161, 174, 0.5)';
          
        } else if (s.type === 'gauge') {
          // Enhanced gauge styling with white background, colored progress, and animated arrow
          if (!s.itemStyle) s.itemStyle = {};
          s.itemStyle.color = designColors.primary;
          
          // Increase radius to fill the space better
          s.radius = '85%';
          s.center = ['50%', '55%'];
          
          // Progress overlay (colored arc)
          if (!s.progress) s.progress = {};
          s.progress.show = true;
          s.progress.width = 22;
          s.progress.itemStyle = {
            color: '#C91F3B',
            shadowBlur: 10,
            shadowColor: 'rgba(201, 31, 59, 0.3)'
          };
          
          // Background arc (white/light gray)
          if (!s.axisLine) s.axisLine = {};
          if (!s.axisLine.lineStyle) s.axisLine.lineStyle = {};
          s.axisLine.lineStyle.width = 22;
          s.axisLine.lineStyle.color = [[1, '#f3f4f6']]; // Light gray background
          
          // Remove ticks for cleaner look
          s.axisTick = { show: false };
          
          // Subtle split lines
          if (!s.splitLine) s.splitLine = {};
          s.splitLine.length = 18;
          s.splitLine.lineStyle = {
            width: 2,
            color: '#ddd'
          };
          
          // Axis labels styling
          if (!s.axisLabel) s.axisLabel = {};
          s.axisLabel.distance = 30;
          s.axisLabel.color = '#999';
          s.axisLabel.fontSize = 13;
          s.axisLabel.fontFamily = 'Cairo';
          
          // Animated pointer (arrow)
          if (!s.pointer) s.pointer = {};
          s.pointer.show = true;
          s.pointer.length = '75%';
          s.pointer.width = 8;
          s.pointer.itemStyle = {
            color: '#C91F3B',
            shadowBlur: 5,
            shadowColor: 'rgba(201, 31, 59, 0.4)'
          };
          
          // Anchor (center dot where arrow rotates from)
          if (!s.anchor) s.anchor = {};
          s.anchor.show = true;
          s.anchor.showAbove = true;
          s.anchor.size = 22;
          s.anchor.itemStyle = {
            color: '#C91F3B',
            borderWidth: 5,
            borderColor: '#fff',
            shadowBlur: 5,
            shadowColor: 'rgba(201, 31, 59, 0.3)'
          };
          
          // Detail (percentage value below gauge)
          if (s.detail) {
            s.detail.color = '#C91F3B';
            s.detail.fontFamily = 'Cairo';
            s.detail.fontWeight = 'bold';
            s.detail.fontSize = 42;
            s.detail.valueAnimation = true;
            s.detail.formatter = '{value}%';
            s.detail.offsetCenter = [0, '75%']; // Position below the gauge
          }
          
          // Title (optional - can be removed if not in API data)
          if (s.title) {
            s.title.fontFamily = 'Cairo';
            s.title.fontSize = 12;
            s.title.fontWeight = '500';
            s.title.color = '#999';
            s.title.offsetCenter = [0, '90%'];
          }
          
          // Smooth animations - both arrow and progress animate together
          s.animationDuration = 2500;
          s.animationEasing = 'cubicOut';
          s.animationEasingUpdate = 'cubicOut';
          s.animationDurationUpdate = 1500;
          
        } else if (s.type === 'bar') {
          // Enhanced bar styling
          if (!s.itemStyle) s.itemStyle = {};
          if (!s.itemStyle.color) s.itemStyle.color = designColors.primary;
          
          // Bar animations with stagger
          s.animationDuration = 1500;
          s.animationEasing = 'cubicOut';
          if (!s.animationDelay) {
            s.animationDelay = (idx: number) => idx * 100;
          }
          
          // Label styling
          if (s.label) {
            s.label.fontFamily = 'Cairo';
            s.label.fontWeight = 'bold';
          }
        } else {
          if (!s.itemStyle) s.itemStyle = {};
          if (!s.itemStyle.color) s.itemStyle.color = designColors.primary;
        }
        
        return s;
      });
    }
    
    return cloned;
  }

  // Export dashboard data to CSV
  exportDashboardData() {
    const exportData: any = {
      strategyName: this.strategyOptions.find(s => s.strategyId === this.selectedStrategyId)?.name || '',
      exportDate: new Date().toISOString(),
      filters: {
        year: this.filteredProjectsYear?.name || 'All Years',
        departmentYear: this.departmentProjectsYear?.name || 'All Years'
      },
      summaryCards: this.summaryCards,
      performanceCards: this.performnceCards?.map(card => ({
        name: card.name,
        count: card.count
      })),
      departments: this.departments?.map(dept => ({
        departmentName: dept.departmentName,
        totalProjects: dept.totalProjects,
        averageProgress: dept.averageProgress
      })),
      topStrategicHighlights: this.topStrategicHighlights
    };

    // Convert to CSV format
    let csv = '';
    
    // Header
    csv += `Dashboard Report - ${exportData.strategyName}\n`;
    csv += `Export Date: ${new Date().toLocaleString()}\n`;
    csv += `Year Filter: ${exportData.filters.year}\n`;
    csv += `Department Year: ${exportData.filters.departmentYear}\n\n`;
    
    // Performance Cards
    csv += 'Performance Summary\n';
    csv += 'Metric,Value\n';
    exportData.performanceCards?.forEach((card: any) => {
      csv += `"${card.name}",${card.count}\n`;
    });
    csv += '\n';
    
    // Department Performance
    csv += 'Department Performance\n';
    csv += 'Department Name,Total Projects,Average Progress (%)\n';
    exportData.departments?.forEach((dept: any) => {
      csv += `"${dept.departmentName}",${dept.totalProjects},${dept.averageProgress.toFixed(2)}\n`;
    });
    
    // Create download link
    const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    const filename = `Dashboard_Report_${new Date().getTime()}.csv`;
    
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    console.log('Dashboard data exported successfully!');
  }

  // Export dashboard data to Excel (HTML table format that Excel can open)
  exportToExcel() {
    const strategyName = this.strategyOptions.find(s => s.strategyId === this.selectedStrategyId)?.name || '';
    const exportDate = new Date().toLocaleString();
    const yearFilter = this.filteredProjectsYear?.name || 'All Years';
    const deptYearFilter = this.departmentProjectsYear?.name || 'All Years';
    
    // Create HTML table that Excel can open
    let html = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">
      <head>
        <meta charset="UTF-8">
        <style>
          table { border-collapse: collapse; width: 100%; }
          th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
          th { background-color: #C91F3B; color: white; font-weight: bold; }
          .header { font-size: 16px; font-weight: bold; margin: 10px 0; }
          .info { margin: 5px 0; }
        </style>
      </head>
      <body>
        <div class="header">تقرير لوحة المعلومات - Dashboard Report</div>
        <div class="info"><strong>الاستراتيجية / Strategy:</strong> ${strategyName}</div>
        <div class="info"><strong>تاريخ التصدير / Export Date:</strong> ${exportDate}</div>
        <div class="info"><strong>السنة / Year:</strong> ${yearFilter}</div>
        <div class="info"><strong>سنة الإدارة / Department Year:</strong> ${deptYearFilter}</div>
        <br/>
        
        <h3>ملخص الأداء / Performance Summary</h3>
        <table>
          <thead>
            <tr>
              <th>المؤشر / Metric</th>
              <th>القيمة / Value</th>
            </tr>
          </thead>
          <tbody>`;
    
    // Performance Cards
    this.performnceCards?.forEach(card => {
      html += `
            <tr>
              <td>${card.name}</td>
              <td>${card.count}</td>
            </tr>`;
    });
    
    html += `
          </tbody>
        </table>
        <br/>
        
        <h3>أداء الإدارات / Department Performance</h3>
        <table>
          <thead>
            <tr>
              <th>اسم الإدارة / Department Name</th>
              <th>إجمالي المشاريع / Total Projects</th>
              <th>متوسط التقدم % / Average Progress %</th>
            </tr>
          </thead>
          <tbody>`;
    
    // Department Performance
    this.departments?.forEach(dept => {
      html += `
            <tr>
              <td>${dept.departmentName}</td>
              <td>${dept.totalProjects}</td>
              <td>${dept.averageProgress.toFixed(2)}%</td>
            </tr>`;
    });
    
    html += `
          </tbody>
        </table>
        <br/>
        
        <h3>أبرز المؤشرات الاستراتيجية / Top Strategic Highlights</h3>
        <table>
          <thead>
            <tr>
              <th>نوع / Type</th>
              <th>الاسم / Name</th>
              <th>القيمة / Value</th>
            </tr>
          </thead>
          <tbody>`;
    
    // Top Strategic Highlights
    if (this.topStrategicHighlights?.goal) {
      html += `
            <tr>
              <td>الهدف / Goal</td>
              <td>${this.topStrategicHighlights.goal.name || '-'}</td>
              <td>${this.topStrategicHighlights.goal.weight || '-'}</td>
            </tr>`;
    }
    
    if (this.topStrategicHighlights?.indicator) {
      html += `
            <tr>
              <td>المؤشر / Indicator</td>
              <td>${this.topStrategicHighlights.indicator.name || '-'}</td>
              <td>${this.topStrategicHighlights.indicator.currentValue || '-'}</td>
            </tr>`;
    }
    
    if (this.topStrategicHighlights?.project) {
      html += `
            <tr>
              <td>المشروع / Project</td>
              <td>${this.topStrategicHighlights.project.name || '-'}</td>
              <td>${this.topStrategicHighlights.project.progressPercentage || 0}%</td>
            </tr>`;
    }
    
    html += `
          </tbody>
        </table>
      </body>
      </html>`;
    
    // Create Excel file (XLS format that opens in Excel)
    const blob = new Blob(['\ufeff' + html], { 
      type: 'application/vnd.ms-excel;charset=utf-8;' 
    });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    const filename = `Dashboard_Report_${new Date().getTime()}.xls`;
    
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    console.log('Excel file exported successfully!');
  }
  
  private createPieChartForIndicator(indicator: any): any {
    const outcomes = indicator['mob_charts']['data'] || [];
    
    // Calculate total target and actual values
    const totalTarget = outcomes.reduce((sum: number, outcome: any) => sum + (outcome.target || 0), 0);
    const totalActual = outcomes.reduce((sum: number, outcome: any) => sum + (outcome.actual || 0), 0);
    
    // Create pie chart data
    const pieData = [
      {
        name: 'المستهدف',
        value: totalTarget,
        itemStyle: {
          color: '#22c55e'
        }
      },
      {
        name: 'المحقق',
        value: totalActual,
        itemStyle: {
          color: '#A71932'
        }
      }
    ];

    return {
      customType: "pie-chart",
      metaData: {
        name: indicator.name,
        in_charge_name: indicator.in_charge_name,
      },
      series: [{
        type: 'pie',
        radius: ['40%', '70%'],
        center: ['50%', '50%'],
        data: pieData,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        label: {
          show: true,
          formatter: (params: any) => {
            return `${params.name}\n${params.value}`;
          },
          fontSize: 11,
          fontFamily: 'Cairo',
          fontWeight: 'bold',
          position: 'outside',
          distance: 10
        },
        labelLine: {
          show: true
        }
      }],
      tooltip: {
        trigger: 'item',
        formatter: (params: any) => {
          if (params.value === 0) {
            return '';
          }
          return `${params.name}: ${params.value} (${params.percent}%)`;
        },
        backgroundColor: '#ffffff',
        borderColor: '#C91F3B',
        borderWidth: 1,
        textStyle: {
          fontFamily: 'Cairo',
          fontSize: 12
        }
      },
      legend: {
        show: false
      }
    };
  }

  // Switch between tabs
  switchTab(tabId: string) {
    this.activeTab = tabId;
    console.log('Switched to tab:', tabId);
    
    // Regenerate charts to trigger animations on every tab switch
    switch (tabId) {
      case 'overview':
        // Regenerate overview charts with animations
        setTimeout(() => {
          this.generateProgressTrendChart();
          this.generateTopIndicatorsPieChart();
          this.generateIndicatorWeightsChart();
          this.generateIndicatorPerformanceDonutChart();
          this.setDepartmentsProjectsPerYearChart();
        }, 100);
        break;
        
      case 'departments':
        console.log('🔄 Departments tab selected, loading data...');
        // Always load fresh data when switching to departments tab
        this.loadDepartmentPerformanceData();
        
        // Regenerate charts with animations
        setTimeout(() => {
          this.setDepartmentsProjectsPerYearChart();
          this.generateDepartmentWorkloadChart();
          this.generateDepartmentTrendChart();
        }, 100);
        break;
        
      case 'projects':
        console.log('🔄 Projects tab selected, loading data...');
        // Always load fresh data when switching to projects tab
        this.loadStrategicProjectsData();
        
        // Regenerate charts with animations
        setTimeout(() => {
          this.setfilteredProjectsPerYearChart();
          this.generateProjectBudgetChart();
          this.generateProjectFunnelChart();
        }, 100);
        break;
        
      case 'impact':
        console.log('🔄 Impact tab selected, loading data...');
        // Always load fresh data when switching to impact tab
        this.loadImpactCompetitivenessData();
        
        // Regenerate charts with animations
        setTimeout(() => {
          this.generateRiskChart();
          this.generateCompetitiveChart();
          this.generateRiskMitigationChart();
        }, 100);
        break;
    }
  }
  
  // Load Department Performance Data from API
  applyDepartmentSummary(response: any) {
    const data = response?.data || response;
    if (!data) {
      return;
    }
    if (!this.departmentKPIs?.length) {
      this.initializeDepartmentKPIs();
    }

    const totalDepts = Number(
      data.totalDepartments ?? data.TotalDepartments ?? data.total_departments ?? 0
    );
    const totalOffs = Number(
      data.totalOffices ?? data.TotalOffices ?? data.totalSections ?? data.TotalSections ?? data.total_offices ?? 0
    );
    const overallProg = Number(data.overallProgress ?? data.OverallProgress ?? 0);

    this.departmentKPIs[0].value = totalDepts.toString();
    this.departmentKPIs[1].value = totalOffs.toString();
    this.departmentKPIs[2].value = `${overallProg.toFixed(1)}%`;
  }

  loadDepartmentPerformanceData() {
    this.dashboardService.getDepartmentPerformance(this.selectedStrategyId).subscribe({
      next: (response: any) => {
        const data = response?.data || response;
        const apiKpis = data?.KPIs || data?.kpIs || data?.kpis;
        
        // Update KPIs from API data
        if (apiKpis && Array.isArray(apiKpis)) {
          const colorMap: any = {
            'total_departments': '#C91F3B',
            'total_offices': '#22c55e',
            'overall_progress': '#A71932'
          };
          
          this.departmentKPIs = apiKpis.map((kpi: any) => {
            const label = kpi.Label ?? kpi.label;
            return {
              label,
              value: kpi.Value ?? kpi.value,
              icon: kpi.Icon ?? kpi.icon,
              color: colorMap[label] || '#C91F3B'
            };
          });
        }
        
        // Charts are already generated by loadTop5Departments
        // Only update if API provides specific chart data
        if (data?.TrendChart) {
          this.updateDepartmentTrendChart(data.TrendChart);
        }
        
        if (data?.WorkloadChart) {
          this.updateDepartmentWorkloadChart(data.WorkloadChart);
        }
      },
      error: (error) => {
        console.error('Error loading department performance data:', error);
      }
    });
  }
  
  // Load Strategic Projects Data from API
  loadStrategicProjectsData() {
    console.log('📊 Loading projects data for strategy:', this.selectedStrategyId);
    
    // Load dashboard data first to get the status chart
    this.dashboardService.getStrategicProjectsData(this.selectedStrategyId).subscribe({
      next: (response: any) => {
        const data = response.data;
        
        console.log('📊 Raw API response:', response);
        console.log('📊 API data:', data);
        console.log('📊 data.KPIs:', (data as any).KPIs);
        console.log('📊 data.kpIs:', (data as any).kpIs);
        
        // Update KPIs from API data (support KPIs | kpIs)
        const apiKpis = (data as any).KPIs || (data as any).kpIs;
        console.log('📊 apiKpis selected:', apiKpis);
        
        if (apiKpis && Array.isArray(apiKpis)) {
          console.log('📊 Updating projectKPIs with:', apiKpis);
          const colorMap: any = {
            'active_projects': '#C91F3B',
            'completed_projects': '#10b981',
            'average_progress': '#E0455C'
          };
          
          this.projectKPIs = apiKpis.map((kpi: any) => {
            const label = kpi.Label ?? kpi.label;
            const value = kpi.Value ?? kpi.value;
            const icon = kpi.Icon ?? kpi.icon;
            console.log(`  Mapping KPI: label=${label}, value=${value}, icon=${icon}`);
            return {
              label: label,
              value: value,
              icon: icon,
              color: colorMap[label] || '#C91F3B'
            };
          });
          
          console.log('✅ Updated projectKPIs:', this.projectKPIs);
          console.log('✅ projectKPIs array length:', this.projectKPIs.length);
          
          // Check if all values are zero
          const allZero = this.projectKPIs.every(kpi => 
            kpi.value === '0' || kpi.value === '0%'
          );
          
          if (allZero) {
            console.warn('⚠️ All project KPIs are zero. This strategy may have no projects.');
            console.log('💡 Tip: Check if strategy ID', this.selectedStrategyId, 'has any projects in the database.');
          }
        } else {
          console.warn('⚠️ No KPIs data received from API');
        }
        
        // Map StatusChart to expected format (support StatusChart | statusChart)
        const statusChartAny = (data as any).StatusChart || (data as any).statusChart;
        if (statusChartAny) {
          console.log('📊 Status chart from API:', statusChartAny);
          
          // Transform the API format to match what the chart expects
          const statusChart = statusChartAny;
          const statusNames = statusChart.StatusNames || statusChart.statusNames || [];
          const statusCounts = statusChart.StatusCounts || statusChart.statusCounts || [];
          
          // Map status names to Arabic
          const statusNameMap: any = {
            'draft': { ar: 'مسودة', en: 'Draft' },
            'pending': { ar: 'قيد المراجعة', en: 'Pending Review' },
            'approved': { ar: 'معتمدة', en: 'Approved' },
            'rejected': { ar: 'مرفوضة', en: 'Rejected' },
            'in_progress': { ar: 'قيد التنفيذ', en: 'In Progress' },
            'in-progress': { ar: 'قيد التنفيذ', en: 'In Progress' },
            'completed': { ar: 'مكتمل', en: 'Completed' },
            'on_hold': { ar: 'متوقف', en: 'On Hold' }
          };
          
          // Create properly formatted names
          const arNames = statusNames.map((name: string) => statusNameMap[name]?.ar || name);
          const enNames = statusNames.map((name: string) => statusNameMap[name]?.en || name);
          
          // Set projectsStatusChart with 'all' year data
          this.projectsStatusChart = {
            names: { ar: arNames, en: enNames },
            data: { 'all': statusCounts }
          };
          
          console.log('📊 Transformed projectsStatusChart:', this.projectsStatusChart);
        }
        
        // Update TimelineChart from API (support TimelineChart | timelineChart)
        const timelineChartAny = (data as any).TimelineChart || (data as any).timelineChart;
        if (timelineChartAny) {
          this.updateProjectTimelineChart(timelineChartAny);
        }
        
        // Now refresh the status chart
        this.setfilteredProjectsPerYearChart();
      },
      error: (error) => {
        console.error('❌ Error loading strategic projects data:', error);
        console.error('API URL:', `strategic-projects/${this.selectedStrategyId}`);
        console.error('Error details:', error.error || error.message);
      }
    });
    
    // Also fetch the actual projects list for budget and funnel charts
    this.projectService.getListProjects(this.selectedStrategyId).subscribe({
      next: (projectsList: IProject[]) => {
        console.log('📊 Fetched projects from ProjectService:', projectsList);
        console.log('📊 Number of projects loaded:', projectsList?.length || 0);
        
        // Update the projects array with real data
        this.projects = projectsList || [];
        
        // Log first project to see its structure
        if (this.projects.length > 0) {
          console.log('📊 Sample project structure:', this.projects[0]);
        }
        
        // Regenerate budget and funnel charts with real data
        setTimeout(() => {
          this.generateProjectBudgetChart();
          this.generateProjectFunnelChart();
        }, 100);
      },
      error: (error) => {
        console.error('❌ Error loading projects from ProjectService:', error);
      }
    });
  }
  
  // Load Impact & Competitiveness Data from API
  loadImpactCompetitivenessData() {
    this.dashboardService.getImpactCompetitiveness(this.selectedStrategyId).subscribe({
      next: (response: any) => {
        const data = response.data;
        
        // Update KPIs from API data
        if (data.KPIs && Array.isArray(data.KPIs)) {
          this.impactKPIs = data.KPIs.map((kpi: any, index: number) => ({
            label: this.mapLabelToTranslationKey(kpi.label || kpi.key) || this.impactKPIs[index]?.label,
            value: kpi.value || this.impactKPIs[index]?.value,
            icon: this.normalizeIconClasses(kpi.icon) || this.impactKPIs[index]?.icon,
            color: kpi.color || this.impactKPIs[index]?.color
          }));
        }
        
        // Update charts with API data if available
        if (data.RiskChart) {
          this.updateRiskChart(data.RiskChart);
        }
        if (data.CompetitiveChart) {
          this.updateCompetitiveChart(data.CompetitiveChart);
        }
        if (data.MitigationChart) {
          this.updateRiskMitigationChart(data.MitigationChart);
        }
        if (data.ImpactTrendChart) {
          this.updateImpactTrendChart(data.ImpactTrendChart);
        }
      },
      error: (error) => {
        console.error('Error loading impact competitiveness data:', error);
      }
    });
  }
  
  // Load Environmental Indicators Data from API
  loadEnvironmentalIndicatorsData() {
    this.dashboardService.getEnvironmentalIndicators(this.selectedStrategyId).subscribe({
      next: (response: any) => {
        const data = response.data;
        
        // Update KPIs from API data
        if (data.KPIs && Array.isArray(data.KPIs)) {
          this.environmentalKPIs = data.KPIs.map((kpi: any, index: number) => ({
            label: this.mapLabelToTranslationKey(kpi.label || kpi.key) || this.environmentalKPIs[index]?.label,
            value: kpi.value || this.environmentalKPIs[index]?.value,
            icon: this.normalizeIconClasses(kpi.icon) || this.environmentalKPIs[index]?.icon,
            color: kpi.color || this.environmentalKPIs[index]?.color
          }));
        }
        
        // Update charts with API data if available
        if (data.GoalsAchievementChart) {
          this.updateGoalsAchievementChart(data.GoalsAchievementChart);
        }
        if (data.IndicatorDistributionChart) {
          this.updateIndicatorDistributionChart(data.IndicatorDistributionChart);
        }
        if (data.PillarCoverageChart) {
          this.updatePillarCoverageChart(data.PillarCoverageChart);
        }
        if (data.ProgressTrendChart) {
          this.updateIndicatorsProgressChart(data.ProgressTrendChart);
        }
      },
      error: (error) => {
        console.error('Error loading environmental indicators data:', error);
      }
    });
  }
  
  // Update tab labels when language changes
  updateTabLabels() {
    this.dashboardTabs = [
      { 
        id: 'overview', 
        label: this.dir === 'rtl' ? 'نظرة عامة' : 'Overview',
        icon: 'fa-solid fa-chart-line'
      },
      { 
        id: 'departments', 
        label: this.dir === 'rtl' ? 'أداء الإدارات' : 'Department Performance',
        icon: 'fa-solid fa-building'
      },
      { 
        id: 'projects', 
        label: this.dir === 'rtl' ? 'المشاريع الاستراتيجية' : 'Strategic Projects',
        icon: 'fa-solid fa-rocket'
      },
      { 
        id: 'impact', 
        label: this.dir === 'rtl' ? 'الأثر والتنافسية' : 'Impact & Competitiveness',
        icon: 'fa-solid fa-trophy'
      }
    ];
  }
  
  // Initialize all tabs data
  initializeAllTabsData() {
    this.initializeDepartmentKPIs();
    this.initializeProjectKPIs();
    this.initializeImpactKPIs();
    this.initializeEnvironmentalKPIs();
    
    this.generateDepartmentTrendChart();
    this.generateDepartmentWorkloadChart();
    this.generateProjectTimelineChart();
    this.generateProjectBudgetChart();
    this.generateProjectFunnelChart();
    this.generateRiskChart();
    this.generateRiskMitigationChart();
    this.generateImpactTrendChart();
    this.generateCompetitiveChart();
    // Environmental tab removed - no need to initialize its charts
  }
  
  // Initialize Department KPIs - Only 3 KPIs
  initializeDepartmentKPIs() {
    // These will be updated from API
    this.departmentKPIs = [
      {
        label: 'total_departments',
        value: '0',
        icon: 'fa-solid fa-building',
        color: '#C91F3B'
      },
      {
        label: 'total_offices',
        value: '5',
        icon: 'fa-solid fa-landmark',
        color: '#22c55e'
      },
      {
        label: 'overall_progress',
        value: '0%',
        icon: 'fa-solid fa-chart-line',
        color: '#A71932'
      }
    ];
  }
  
  // Initialize Project KPIs
  initializeProjectKPIs() {
    // These will be updated from API
    this.projectKPIs = [
      {
        label: 'active_projects',
        value: '0',
        icon: 'fa-solid fa-rocket',
        color: '#C91F3B'
      },
      {
        label: 'completed_projects',
        value: '0',
        icon: 'fa-solid fa-check-circle',
        color: '#10b981'
      },
      {
        label: 'average_progress',
        value: '0%',
        icon: 'fa-solid fa-tasks',
        color: '#E0455C'
      }
    ];
  }
  
  // Initialize Impact KPIs
  initializeImpactKPIs() {
    // Generate realistic data based on strategy performance
    const totalRisks = 18;
    const criticalRisks = Math.floor(Math.random() * 4) + 2; // 2-5 critical risks
    const managedRisks = totalRisks - criticalRisks;
    const competitiveIndex = (Math.random() * 2 + 7).toFixed(1); // 7.0-9.0
    const impactRate = Math.floor(Math.random() * 20 + 75); // 75-95%
    
    this.impactKPIs = [
      {
        label: 'critical_risks',
        value: criticalRisks.toString(),
        icon: 'fa-solid fa-circle-exclamation',
        color: '#ef4444'
      },
      {
        label: 'managed_risks',
        value: managedRisks.toString(),
        icon: 'fa-solid fa-shield-halved',
        color: '#10b981'
      },
      {
        label: 'competitive_index',
        value: `${competitiveIndex}/10`,
        icon: 'fa-solid fa-trophy',
        color: '#f59e0b'
      },
      {
        label: 'impact_rate',
        value: `${impactRate}%`,
        icon: 'fa-solid fa-chart-area',
        color: '#C91F3B'
      }
    ];
  }
  
  // Initialize Environmental KPIs
  initializeEnvironmentalKPIs() {
    // These will be updated from API once endpoint is available
    this.environmentalKPIs = [
      {
        label: 'goals_achieved',
        value: '12/15',
        icon: 'fa-solid fa-bullseye',
        color: '#C91F3B'
      },
      {
        label: 'environmental_indicators',
        value: '28',
        icon: 'fa-solid fa-leaf',
        color: '#10b981'
      },
      {
        label: 'achievement_rate',
        value: '80%',
        icon: 'fa-solid fa-percent',
        color: '#E0455C'
      },
      {
        label: 'sustainability',
        value: '92%',
        icon: 'fa-solid fa-recycle',
        color: '#A71932'
      }
    ];
  }
  
  // Generate Department Trend Chart - Grouped Bar Chart for Top 3 Departments
  generateDepartmentTrendChart() {
    console.log('🔧 generateDepartmentTrendChart called');
    console.log('📊 this.departments:', this.departments);
    console.log('📊 this.departments.length:', this.departments?.length);
    
    // Get top 3 departments by average progress
    let top3Departments = this.departments
      .sort((a, b) => b.averageProgress - a.averageProgress)
      .slice(0, 3);
    
    console.log('📊 top3Departments after sorting:', top3Departments);
    
    // If no data from API, use default/sample data
    if (top3Departments.length === 0) {
      console.log('⚠️ No department data, using sample data for trend chart');
      top3Departments = [
        { departmentName: this.dir === 'rtl' ? 'الإدارة الأولى' : 'Department 1', averageProgress: 75, totalProjects: 10, completedProjects: 7 },
        { departmentName: this.dir === 'rtl' ? 'الإدارة الثانية' : 'Department 2', averageProgress: 60, totalProjects: 8, completedProjects: 5 },
        { departmentName: this.dir === 'rtl' ? 'الإدارة الثالثة' : 'Department 3', averageProgress: 45, totalProjects: 6, completedProjects: 3 }
      ] as any[];
      console.log('✅ Using sample data:', top3Departments);
    } else {
      console.log('✅ Using real API data:', top3Departments);
    }
    
    // Fallback removed - we always have data now
    if (false) {
      this.departmentTrendChartOptions = {
        animation: true,
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          borderColor: '#C91F3B',
          borderWidth: 1,
          textStyle: { fontFamily: 'Cairo', fontSize: 11 }
        },
        grid: { left: '8%', right: '5%', bottom: '12%', top: '8%', containLabel: true },
        xAxis: {
          type: 'category',
          data: [this.dir === 'rtl' ? 'لا توجد بيانات' : 'No Data'],
          axisLabel: { fontFamily: 'Cairo', fontSize: 10 }
        },
        yAxis: {
          type: 'value',
          max: 100,
          axisLabel: { formatter: '{value}%', fontFamily: 'Cairo', fontSize: 9 }
        },
        series: []
      };
      return;
    }
    
    // Colors for the bars
    const colors = ['#C91F3B', '#A71932', '#22c55e'];
    
    // Department names for x-axis
    const departmentNames = top3Departments.map(d => {
      // Truncate long names
      return d.departmentName.length > 15 
        ? d.departmentName.substring(0, 15) + '...' 
        : d.departmentName;
    });
    
    // Create series data
    const seriesData = top3Departments.map((dept, index) => ({
      value: Math.round(dept.averageProgress || 0),
      itemStyle: { 
        color: colors[index],
        borderRadius: [8, 8, 0, 0]
      },
      label: {
        show: true,
        position: 'top',
        formatter: '{c}%',
        fontFamily: 'Cairo',
        fontSize: 11,
        fontWeight: 'bold',
        color: colors[index]
      },
      // Add metadata for tooltip
      totalProjects: dept.totalProjects,
      completedProjects: dept.completedProjects || 0,
      fullName: dept.departmentName
    }));
    
    this.departmentTrendChartOptions = {
      animation: true,
      animationDuration: 2000,
      animationEasing: 'elasticOut',
      tooltip: {
        trigger: 'axis',
        backgroundColor: '#fff',
        borderColor: '#C91F3B',
        borderWidth: 1,
        axisPointer: {
          type: 'shadow',
          shadowStyle: {
            color: 'rgba(201, 31, 59, 0.1)'
          }
        },
        textStyle: { fontFamily: 'Cairo', fontSize: 11 },
        formatter: (params: any) => {
          const data = params[0];
          const index = data.dataIndex;
          const dept = top3Departments[index];
          
          return `<div style="font-family: Cairo; padding: 8px;">
            <strong>${dept.departmentName}</strong><br/>
            ${this.dir === 'rtl' ? 'نسبة الإنجاز' : 'Progress'}: <strong>${data.value}%</strong><br/>
            ${this.dir === 'rtl' ? 'المشاريع' : 'Projects'}: <strong>${dept.totalProjects || 0}</strong><br/>
            ${this.dir === 'rtl' ? 'المكتملة' : 'Completed'}: <strong>${dept.completedProjects || 0}</strong>
          </div>`;
        }
      },
      grid: { 
        left: '8%', 
        right: '8%', 
        bottom: '12%', 
        top: '8%', 
        containLabel: true 
      },
      xAxis: {
        type: 'category',
        data: departmentNames,
        axisLabel: { 
          fontFamily: 'Cairo', 
          fontSize: 11,
          interval: 0,
          rotate: this.dir === 'rtl' ? 0 : 0,
          color: '#000000',  // Black color for department names
          fontWeight: '500'
        },
        axisLine: {
          lineStyle: { color: '#e5e7eb' }
        }
      },
      yAxis: {
        type: 'value',
        max: 100,
        axisLabel: { 
          formatter: '{value}%', 
          fontFamily: 'Cairo', 
          fontSize: 9,
          color: '#6b7280'
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#e5e7eb'
          }
        }
      },
      series: [
        {
          name: this.dir === 'rtl' ? 'نسبة الإنجاز' : 'Progress Rate',
          type: 'bar',
          barWidth: '50%',
          data: seriesData,
          animationDelay: (idx: number) => idx * 200,
          animationEasing: 'elasticOut'
        }
      ]
    };
    
    console.log('✅ Department Trend Chart Options Generated:', this.departmentTrendChartOptions);
    console.log('📊 Chart has', this.departmentTrendChartOptions.series[0].data.length, 'data points');
    
    // Force change detection to ensure chart renders
    this.cdr.detectChanges();
  }
  
  // Generate Project Timeline Chart
  generateProjectTimelineChart() {
    console.log('🔧 generateProjectTimelineChart called');
    // Will be updated from API, using placeholder initially
    const quarters = this.dir === 'rtl' 
      ? ['الربع 1', 'الربع 2', 'الربع 3', 'الربع 4']
      : ['Q1', 'Q2', 'Q3', 'Q4'];
    
    this.projectTimelineChartOptions = {
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        backgroundColor: '#fff',
        borderColor: '#C91F3B',
        textStyle: { fontFamily: 'Cairo', fontSize: 11 }
      },
      grid: { left: '5%', right: '5%', bottom: '15%', top: '8%', containLabel: true },
      xAxis: {
        type: 'category',
        data: quarters,
        axisLabel: { fontFamily: 'Cairo', fontSize: 10 }
      },
      yAxis: {
        type: 'value',
        axisLabel: { fontFamily: 'Cairo', fontSize: 9 }
      },
      series: [
        {
          name: this.dir === 'rtl' ? 'مشاريع مخططة' : 'Planned',
          type: 'bar',
          stack: 'total',
          data: [0, 0, 0, 0],
          itemStyle: { color: '#A71932' }
        },
        {
          name: this.dir === 'rtl' ? 'مشاريع مكتملة' : 'Completed',
          type: 'bar',
          stack: 'total',
          data: [0, 0, 0, 0],
          itemStyle: { color: '#C91F3B' }
        }
      ]
    };
    
    console.log('✅ Project Timeline Chart Generated');
    this.cdr.detectChanges();
  }
  
  // Generate Risk Bubble Chart with Quadrants
  generateRiskChart() {
    const riskCategories = this.dir === 'rtl'
      ? ['منخفضة', 'متوسطة', 'عالية', 'حرجة']
      : ['Low', 'Medium', 'High', 'Critical'];
    
    // Generate realistic risk data: [impact (1-10), likelihood (1-10), severity score, category index]
    const lowRisks = Array.from({ length: 5 }, () => [
      Math.random() * 4 + 1,  // Impact: 1-5
      Math.random() * 4 + 1,  // Likelihood: 1-5
      Math.floor(Math.random() * 15) + 5, // Severity: 5-20
      0 // Category: Low
    ]);
    
    const mediumRisks = Array.from({ length: 8 }, () => [
      Math.random() * 5 + 3,  // Impact: 3-8
      Math.random() * 5 + 3,  // Likelihood: 3-8
      Math.floor(Math.random() * 20) + 15, // Severity: 15-35
      1 // Category: Medium
    ]);
    
    const highRisks = Array.from({ length: 4 }, () => [
      Math.random() * 4 + 6,  // Impact: 6-10
      Math.random() * 4 + 4,  // Likelihood: 4-8
      Math.floor(Math.random() * 25) + 30, // Severity: 30-55
      2 // Category: High
    ]);
    
    const criticalRisks = Array.from({ length: 2 }, () => [
      Math.random() * 3 + 7,  // Impact: 7-10
      Math.random() * 3 + 7,  // Likelihood: 7-10
      Math.floor(Math.random() * 30) + 50, // Severity: 50-80
      3 // Category: Critical
    ]);
    
    const colors = ['#10b981', '#f59e0b', '#ef4444', '#991b1b'];
    
    this.riskChartOptions = {
      tooltip: {
        formatter: (params: any) => {
          const category = riskCategories[params.value[3]];
          return `<div style="font-family: Cairo; padding: 8px;">
            <strong>${this.dir === 'rtl' ? 'مستوى الخطر' : 'Risk Level'}: ${category}</strong><br/>
            ${this.dir === 'rtl' ? 'الأثر' : 'Impact'}: <strong>${params.value[0].toFixed(1)}/10</strong><br/>
            ${this.dir === 'rtl' ? 'الاحتمالية' : 'Likelihood'}: <strong>${params.value[1].toFixed(1)}/10</strong><br/>
            ${this.dir === 'rtl' ? 'درجة الخطورة' : 'Severity Score'}: <strong>${params.value[2]}</strong>
          </div>`;
        },
        backgroundColor: '#fff',
        borderColor: '#C91F3B',
        borderWidth: 1,
        textStyle: { fontFamily: 'Cairo', fontSize: 11 }
      },
      legend: {
        data: riskCategories,
        bottom: '5%',
        textStyle: {
          fontFamily: 'Cairo',
          fontSize: 10
        },
        itemGap: 15
      },
      grid: {
        left: '12%',
        right: '8%',
        bottom: '18%',
        top: '8%',
        containLabel: true
      },
      xAxis: {
        name: this.dir === 'rtl' ? 'الأثر' : 'Impact',
        nameLocation: 'middle',
        nameGap: 25,
        nameTextStyle: {
          fontFamily: 'Cairo',
          fontSize: 11,
          fontWeight: '500',
          color: '#374151'
        },
        min: 0,
        max: 10,
        interval: 2,
        axisLabel: {
          fontFamily: 'Cairo',
          fontSize: 9,
          color: '#666'
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            color: '#e5e7eb'
          }
        },
        axisLine: {
          lineStyle: { color: '#e5e7eb' }
        }
      },
      yAxis: {
        name: this.dir === 'rtl' ? 'الاحتمالية' : 'Likelihood',
        nameLocation: 'middle',
        nameGap: 35,
        nameTextStyle: {
          fontFamily: 'Cairo',
          fontSize: 11,
          fontWeight: '500',
          color: '#374151'
        },
        min: 0,
        max: 10,
        interval: 2,
        axisLabel: {
          fontFamily: 'Cairo',
          fontSize: 9,
          color: '#666'
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            color: '#e5e7eb'
          }
        },
        axisLine: {
          lineStyle: { color: '#e5e7eb' }
        }
      },
      series: [
        {
          name: riskCategories[0],
          type: 'scatter',
          data: lowRisks,
          symbolSize: (val: any) => Math.sqrt(val[2]) * 3,
          itemStyle: {
            color: colors[0],
            opacity: 0.7
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: colors[0],
              opacity: 1,
              scale: 1.2
            }
          },
          // Bubbles scale up from 0
          animationDuration: 1500,
          animationEasing: 'elasticOut',
          animationDelay: (idx: number) => idx * 100
        },
        {
          name: riskCategories[1],
          type: 'scatter',
          data: mediumRisks,
          symbolSize: (val: any) => Math.sqrt(val[2]) * 3,
          itemStyle: {
            color: colors[1],
            opacity: 0.7
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: colors[1],
              opacity: 1,
              scale: 1.2
            }
          },
          // Bubbles scale up from 0
          animationDuration: 1500,
          animationEasing: 'elasticOut',
          animationDelay: (idx: number) => idx * 100 + 200
        },
        {
          name: riskCategories[2],
          type: 'scatter',
          data: highRisks,
          symbolSize: (val: any) => Math.sqrt(val[2]) * 3,
          itemStyle: {
            color: colors[2],
            opacity: 0.7
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: colors[2],
              opacity: 1,
              scale: 1.2
            }
          },
          // Bubbles scale up from 0
          animationDuration: 1500,
          animationEasing: 'elasticOut',
          animationDelay: (idx: number) => idx * 100 + 400
        },
        {
          name: riskCategories[3],
          type: 'scatter',
          data: criticalRisks,
          symbolSize: (val: any) => Math.sqrt(val[2]) * 3,
          itemStyle: {
            color: colors[3],
            opacity: 0.7
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: colors[3],
              opacity: 1,
              scale: 1.2
            }
          },
          // Bubbles scale up from 0
          animationDuration: 1500,
          animationEasing: 'elasticOut',
          animationDelay: (idx: number) => idx * 100 + 600
        }
      ],
      animation: true,
      animationDuration: 2000,
      animationEasing: 'elasticOut'
    };
  }
  
  // Generate Competitive Chart
  generateCompetitiveChart() {
    const categories = this.dir === 'rtl' 
      ? ['الابتكار', 'الكفاءة', 'الجودة', 'السرعة', 'التكلفة']
      : ['Innovation', 'Efficiency', 'Quality', 'Speed', 'Cost'];
    
    // Generate realistic competitive performance data
    const performanceData = categories.map(() => Math.floor(Math.random() * 25 + 70)); // 70-95
    
    this.competitiveChartOptions = {
      tooltip: {
        trigger: 'axis',
        formatter: (params: any) => {
          const param = params[0];
          return `<div style="font-family: Cairo; padding: 8px;">
            <strong>${param.name}</strong><br/>
            ${this.dir === 'rtl' ? 'الأداء' : 'Performance'}: <strong>${param.value}%</strong>
          </div>`;
        },
        backgroundColor: '#fff',
        borderColor: '#C91F3B',
        borderWidth: 1,
        textStyle: { fontFamily: 'Cairo', fontSize: 11 }
      },
      radar: {
        indicator: categories.map(cat => ({ 
          name: cat, 
          max: 100,
          axisLabel: {
            show: true,
            fontSize: 10,
            color: '#999'
          }
        })),
        shape: 'polygon',
        splitNumber: 4,
        axisName: { 
          fontFamily: 'Cairo', 
          fontSize: 11,
          color: '#374151',
          fontWeight: '500'
        },
        splitLine: {
          lineStyle: {
            color: '#e5e7eb'
          }
        },
        splitArea: {
          show: true,
          areaStyle: {
            color: ['rgba(201, 31, 59, 0.05)', 'rgba(201, 31, 59, 0.1)']
          }
        }
      },
      series: [
        {
          type: 'radar',
          data: [
            {
              value: performanceData,
              name: this.dir === 'rtl' ? 'الأداء الحالي' : 'Current Performance',
              itemStyle: { color: '#C91F3B' },
              lineStyle: {
                width: 3
              },
              areaStyle: { 
                opacity: 0.4,
                color: '#C91F3B'
              },
              label: {
                show: true,
                formatter: '{c}%',
                fontSize: 10,
                fontFamily: 'Cairo',
                color: '#C91F3B',
                fontWeight: 'bold'
              }
            }
          ],
          // Radar shape grows from center
          animationDuration: 2000,
          animationEasing: 'cubicOut'
        }
      ],
      animation: true,
      animationDuration: 2000,
      animationEasing: 'cubicOut'
    };
  }
  
  // Generate Goals Achievement Chart
  generateGoalsAchievementChart() {
    const goals = this.dir === 'rtl'
      ? ['الهدف 1', 'الهدف 2', 'الهدف 3', 'الهدف 4', 'الهدف 5']
      : ['Goal 1', 'Goal 2', 'Goal 3', 'Goal 4', 'Goal 5'];
    
    this.goalsAchievementChartOptions = {
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        backgroundColor: '#fff',
        borderColor: '#C91F3B',
        textStyle: { fontFamily: 'Cairo', fontSize: 11 }
      },
      grid: { left: '3%', right: '4%', bottom: '10%', top: '10%', containLabel: true },
      xAxis: {
        type: 'category',
        data: goals,
        axisLabel: { fontFamily: 'Cairo', fontSize: 9 }
      },
      yAxis: {
        type: 'value',
        max: 100,
        axisLabel: { formatter: '{value}%', fontFamily: 'Cairo', fontSize: 9 }
      },
      series: [
        {
          name: this.dir === 'rtl' ? 'نسبة الإنجاز' : 'Achievement',
          type: 'bar',
          data: [85, 92, 78, 88, 95],
          barWidth: '50%',
          itemStyle: { color: '#C91F3B', borderRadius: [4, 4, 0, 0] }
        }
      ]
    };
  }
  
  // Generate Indicators Progress Chart
  generateIndicatorsProgressChart() {
    const months = this.dir === 'rtl' 
      ? ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو']
      : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
    
    this.indicatorsProgressChartOptions = {
      tooltip: {
        trigger: 'axis',
        backgroundColor: '#fff',
        borderColor: '#C91F3B',
        textStyle: { fontFamily: 'Cairo', fontSize: 11 }
      },
      grid: { left: '5%', right: '5%', bottom: '15%', top: '8%', containLabel: true },
      xAxis: {
        type: 'category',
        data: months,
        axisLabel: { fontFamily: 'Cairo', fontSize: 9 }
      },
      yAxis: {
        type: 'value',
        max: 100,
        axisLabel: { formatter: '{value}%', fontFamily: 'Cairo', fontSize: 9 }
      },
      series: [
        {
          type: 'line',
          data: [60, 68, 75, 80, 85, 90],
          smooth: true,
          areaStyle: {
            color: {
              type: 'linear',
              x: 0, y: 0, x2: 0, y2: 1,
              colorStops: [
                { offset: 0, color: 'rgba(97, 161, 174, 0.5)' },
                { offset: 1, color: 'rgba(97, 161, 174, 0.05)' }
              ]
            }
          },
          lineStyle: { width: 3, color: '#C91F3B' },
          itemStyle: { color: '#C91F3B' }
        }
      ]
    };
  }
  
  // Generate Department Workload Chart - using actual departments data
  generateDepartmentWorkloadChart() {
    console.log('🔧 generateDepartmentWorkloadChart called');
    console.log('📊 this.departments for workload:', this.departments);
    
    // Use actual departments data if available, otherwise use sample data
    if (!this.departments || this.departments.length === 0) {
      console.log('⚠️ No departments data, using sample data for workload chart');
      // Use sample data instead of empty
      this.departments = [
        { departmentName: this.dir === 'rtl' ? 'الإدارة الأولى' : 'Department 1', totalProjects: 10 },
        { departmentName: this.dir === 'rtl' ? 'الإدارة الثانية' : 'Department 2', totalProjects: 8 },
        { departmentName: this.dir === 'rtl' ? 'الإدارة الثالثة' : 'Department 3', totalProjects: 6 }
      ] as any[];
    }
    
    // Use all departments (up to 9)
    const allDepartments = this.departments.slice(0, 9);
    
    // Generate color palette for departments
    const colorPalette = [
      '#C91F3B', '#A71932', '#A71932', '#E0455C', '#8B1529',
      '#1a969f', '#25b5c0', '#10646e', '#2cc4d0'
    ];
    
    // Calculate total projects across all departments
    const totalProjects = allDepartments.reduce((sum, dept) => sum + (dept.totalProjects || 0), 0);
    
    // Build pie chart data
    const pieData = allDepartments.map((dept, index) => ({
      value: dept.totalProjects || 0,
      name: dept.departmentName,
      itemStyle: { color: colorPalette[index] }
    }));
    
    this.departmentWorkloadChartOptions = {
      animation: true,
      animationDuration: 2500,
      animationEasing: 'cubicInOut',
      tooltip: {
        trigger: 'item',
        backgroundColor: '#fff',
        borderColor: '#C91F3B',
        borderWidth: 1,
        textStyle: { fontFamily: 'Cairo', fontSize: 11 },
        formatter: (params: any) => {
          const percentage = ((params.value / totalProjects) * 100).toFixed(1);
          return `<div style="font-family: Cairo; padding: 8px;">
            <strong>${params.name}</strong><br/>
            ${this.dir === 'rtl' ? 'عدد المشاريع' : 'Projects'}: <strong>${params.value}</strong><br/>
            ${this.dir === 'rtl' ? 'النسبة' : 'Percentage'}: <strong>${percentage}%</strong>
          </div>`;
        }
      },
      legend: {
        show: false
      },
      series: [
        {
          type: 'pie',
          radius: '70%',
          center: ['50%', '50%'],
          data: pieData,
          label: {
            show: true,
            formatter: '{b}\n{d}%',
            fontFamily: 'Cairo',
            fontSize: 10,
            fontWeight: 'bold'
          },
          itemStyle: {
            borderRadius: 8,
            borderColor: '#fff',
            borderWidth: 2
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 12,
              shadowColor: 'rgba(201, 31, 59, 0.3)'
            },
            scale: true,
            scaleSize: 10
          },
          animationType: 'expansion',
          animationEasing: 'cubicOut',
          animationDuration: 2200,
          animationDelay: (idx: number) => idx * 150
        }
      ]
    };
    
    console.log('✅ Department Workload Chart Generated');
    this.cdr.detectChanges();
  }
  
  // Generate Project Budget Chart
  generateProjectBudgetChart() {
    console.log('🔧 generateProjectBudgetChart called');
    // Calculate actual budget distribution from projects
    const budgetData = this.calculateBudgetDistribution();
    
    const categories = this.dir === 'rtl'
      ? budgetData.categories.ar
      : budgetData.categories.en;
    
    this.projectBudgetChartOptions = {
      animation: true,
      animationDuration: 2000,
      animationEasing: 'elasticOut',
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        backgroundColor: '#fff',
        borderColor: '#C91F3B',
        textStyle: { fontFamily: 'Cairo', fontSize: 11 }
      },
      grid: { left: '3%', right: '4%', bottom: '10%', top: '10%', containLabel: true },
      xAxis: {
        type: 'category',
        data: categories,
        axisLabel: { fontFamily: 'Cairo', fontSize: 9, rotate: 15 }
      },
      yAxis: {
        type: 'value',
        axisLabel: { formatter: '{value}K', fontFamily: 'Cairo', fontSize: 9 }
      },
      series: [
        {
          type: 'bar',
          data: budgetData.values,
          barWidth: '50%',
          itemStyle: { color: '#C91F3B', borderRadius: [4, 4, 0, 0] },
          animationDuration: 1800,
          animationEasing: 'elasticOut',
          animationDelay: (idx: number) => idx * 150
        }
      ]
    };
    
    console.log('✅ Project Budget Chart Generated');
    this.cdr.detectChanges();
  }
  
  // Generate Project Completion Progress Chart (changed from funnel to horizontal bar)
  generateProjectFunnelChart() {
    console.log('🔧 generateProjectFunnelChart called');
    // Calculate actual project stages from real data
    const stageData = this.calculateProjectStages();
    
    const stages = this.dir === 'rtl'
      ? stageData.stages.ar
      : stageData.stages.en;
    
    const values = stageData.values;
    // Colors: Completed (green), Final Stage (teal), In Progress (blue), Not Started (orange for visibility)
    const colors = ['#10b981', '#C91F3B', '#E0455C', '#f59e0b'];
    
    this.projectFunnelChartOptions = {
      animation: true,
      animationDuration: 2000,
      animationEasing: 'elasticOut',
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        formatter: (params: any) => {
          const item = params[0];
          return `<div style="font-family: Cairo; padding: 8px;">
            <strong>${item.name}</strong><br/>
            ${this.dir === 'rtl' ? 'عدد المشاريع' : 'Project Count'}: <strong>${item.value}</strong>
          </div>`;
        },
        backgroundColor: '#fff',
        borderColor: '#C91F3B',
        textStyle: { fontFamily: 'Cairo', fontSize: 11 }
      },
      legend: {
        show: false
      },
      grid: {
        left: '15%',
        right: '5%',
        bottom: '8%',
        top: '5%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        axisLabel: {
          fontSize: 10,
          fontFamily: 'Cairo',
          color: '#666'
        },
        splitLine: {
          show: true,
          lineStyle: { type: 'dashed', color: '#e5e7eb' }
        },
        axisTick: { show: false },
        axisLine: { show: false }
      },
      yAxis: {
        type: 'category',
        data: stages,
        axisLabel: {
          fontSize: 11,
          fontFamily: 'Cairo',
          color: '#374151',
          fontWeight: '500'
        },
        axisTick: { show: false },
        axisLine: { show: false }
      },
      series: [
        {
          name: this.dir === 'rtl' ? 'المشاريع' : 'Projects',
          type: 'bar',
          barWidth: '50%',
          label: {
            show: true,
            position: this.dir === 'rtl' ? 'insideLeft' : 'insideRight',
            formatter: '{c}',
            fontSize: 11,
            fontWeight: 'bold',
            color: '#ffffff',
            fontFamily: 'Cairo'
          },
          data: values.map((value: number, index: number) => ({
            value,
            itemStyle: { 
              color: colors[index],
              borderRadius: this.dir === 'rtl' ? [8, 0, 0, 8] : [0, 8, 8, 0]
            }
          })),
          // Horizontal bars grow from left to right (or right to left in RTL)
          animationDuration: 1800,
          animationEasing: 'elasticOut',
          animationDelay: (idx: number) => idx * 150
        }
      ]
    };
    
    console.log('✅ Project Funnel Chart Generated');
    this.cdr.detectChanges();
  }
  
  // Generate Risk Mitigation Chart
  generateRiskMitigationChart() {
    const months = this.dir === 'rtl'
      ? ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو']
      : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
    
    // Generate realistic risk mitigation trend data
    const identifiedRisks = [22, 19, 16, 13, 10, 8];
    const mitigatedRisks = identifiedRisks.map((val, idx) => {
      const mitigation = val - Math.floor(Math.random() * 4 + 2);
      return Math.max(mitigation, idx === 5 ? val - 2 : 0);
    });
    
    this.riskMitigationChartOptions = {
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        formatter: (params: any) => {
          let result = `<div style="font-family: Cairo; padding: 8px;">
            <strong>${params[0].name}</strong><br/>`;
          params.forEach((param: any) => {
            result += `${param.marker} ${param.seriesName}: <strong>${param.value}</strong><br/>`;
          });
          result += '</div>';
          return result;
        },
        backgroundColor: '#fff',
        borderColor: '#C91F3B',
        borderWidth: 1,
        textStyle: { fontFamily: 'Cairo', fontSize: 11 }
      },
      legend: {
        data: [
          this.dir === 'rtl' ? 'مخاطر محددة' : 'Identified Risks',
          this.dir === 'rtl' ? 'مخاطر تم معالجتها' : 'Mitigated Risks'
        ],
        textStyle: { fontFamily: 'Cairo', fontSize: 10 },
        bottom: '8%',
        itemGap: 15
      },
      grid: { left: '8%', right: '5%', bottom: '18%', top: '10%', containLabel: true },
      xAxis: {
        type: 'category',
        data: months,
        axisLabel: { 
          fontFamily: 'Cairo', 
          fontSize: 9,
          color: '#666'
        },
        axisLine: {
          lineStyle: { color: '#e5e7eb' }
        },
        axisTick: { show: false }
      },
      yAxis: {
        type: 'value',
        minInterval: 1,
        axisLabel: { 
          fontFamily: 'Cairo', 
          fontSize: 9,
          color: '#666'
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#e5e7eb'
          }
        },
        axisLine: { show: false },
        axisTick: { show: false }
      },
      series: [
        {
          name: this.dir === 'rtl' ? 'مخاطر محددة' : 'Identified Risks',
          type: 'bar',
          data: identifiedRisks,
          itemStyle: { 
            color: '#ef4444',
            borderRadius: [4, 4, 0, 0]
          },
          label: {
            show: true,
            position: 'top',
            formatter: '{c}',
            fontSize: 10,
            fontFamily: 'Cairo',
            color: '#666'
          },
          // Bars grow from bottom
          animationDuration: 1800,
          animationEasing: 'elasticOut',
          animationDelay: (idx: number) => idx * 120
        },
        {
          name: this.dir === 'rtl' ? 'مخاطر تم معالجتها' : 'Mitigated Risks',
          type: 'bar',
          data: mitigatedRisks,
          itemStyle: { 
            color: '#10b981',
            borderRadius: [4, 4, 0, 0]
          },
          label: {
            show: true,
            position: 'top',
            formatter: '{c}',
            fontSize: 10,
            fontFamily: 'Cairo',
            color: '#666'
          },
          // Bars grow from bottom
          animationDuration: 1800,
          animationEasing: 'elasticOut',
          animationDelay: (idx: number) => idx * 120 + 100
        }
      ],
      animation: true,
      animationDuration: 2000,
      animationEasing: 'elasticOut'
    };
  }
  
  // Generate Strategic Impact Trend Chart
  generateImpactTrendChart() {
    const months = this.dir === 'rtl'
      ? ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس']
      : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'];
    
    // Generate realistic upward trend for strategic impact
    const baseImpact = 65;
    const impactData = months.map((_, idx) => {
      const trend = baseImpact + (idx * 3.5); // Steady upward trend
      const variance = Math.floor(Math.random() * 5) - 2; // Small random variance
      return Math.min(95, Math.floor(trend + variance));
    });
    
    this.impactTrendChartOptions = {
      tooltip: {
        trigger: 'axis',
        formatter: (params: any) => {
          const param = params[0];
          const change = param.dataIndex > 0 
            ? param.value - impactData[param.dataIndex - 1] 
            : 0;
          const changeText = change > 0 
            ? `<span style="color: #10b981;">↑ +${change}%</span>` 
            : change < 0 
              ? `<span style="color: #ef4444;">↓ ${change}%</span>`
              : '<span style="color: #666;">→ 0%</span>';
          return `<div style="font-family: Cairo; padding: 8px;">
            <strong>${param.name}</strong><br/>
            ${this.dir === 'rtl' ? 'الأثر الاستراتيجي' : 'Strategic Impact'}: <strong>${param.value}%</strong><br/>
            ${this.dir === 'rtl' ? 'التغيير' : 'Change'}: ${changeText}
          </div>`;
        },
        backgroundColor: '#fff',
        borderColor: '#C91F3B',
        borderWidth: 1,
        textStyle: { fontFamily: 'Cairo', fontSize: 11 }
      },
      grid: { 
        left: '8%', 
        right: '5%', 
        bottom: '12%', 
        top: '15%', 
        containLabel: true 
      },
      xAxis: {
        type: 'category',
        data: months,
        axisLabel: { 
          fontFamily: 'Cairo', 
          fontSize: 9,
          color: '#666'
        },
        axisLine: {
          lineStyle: { color: '#e5e7eb' }
        },
        axisTick: { show: false }
      },
      yAxis: {
        type: 'value',
        min: 60,
        max: 100,
        interval: 10,
        axisLabel: { 
          formatter: '{value}%', 
          fontFamily: 'Cairo', 
          fontSize: 9,
          color: '#666'
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#e5e7eb'
          }
        },
        axisLine: { show: false },
        axisTick: { show: false }
      },
      series: [
        {
          name: this.dir === 'rtl' ? 'الأثر الاستراتيجي' : 'Strategic Impact',
          type: 'line',
          data: impactData,
          smooth: true,
          symbol: 'circle',
          symbolSize: 8,
          lineStyle: {
            width: 3,
            color: '#C91F3B'
          },
          itemStyle: {
            color: '#C91F3B',
            borderWidth: 2,
            borderColor: '#fff'
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0, y: 0, x2: 0, y2: 1,
              colorStops: [
                { offset: 0, color: 'rgba(201, 31, 59, 0.4)' },
                { offset: 1, color: 'rgba(201, 31, 59, 0.05)' }
              ]
            }
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: 'rgba(201, 31, 59, 0.5)',
              scale: 1.2
            }
          },
          markLine: {
            silent: true,
            symbol: 'none',
            lineStyle: {
              type: 'dashed',
              color: '#10b981',
              width: 2
            },
            data: [
              { 
                yAxis: 85, 
                label: { 
                  show: true,
                  formatter: this.dir === 'rtl' ? 'الهدف: 85%' : 'Target: 85%',
                  fontFamily: 'Cairo',
                  fontSize: 10,
                  color: '#10b981',
                  position: 'insideEndTop'
                }
              }
            ]
          },
          // Line draws from left to right with area fill
          animationDuration: 2500,
          animationEasing: 'cubicOut'
        }
      ],
      animation: true,
      animationDuration: 2500,
      animationEasing: 'cubicOut'
    };
  }
  
  // Generate Indicator Distribution Chart
  generateIndicatorDistributionChart() {
    const categories = this.dir === 'rtl'
      ? ['ممتاز', 'جيد', 'متوسط', 'يحتاج تحسين']
      : ['Excellent', 'Good', 'Average', 'Needs Improvement'];
    
    this.indicatorDistributionChartOptions = {
      tooltip: {
        trigger: 'item',
        backgroundColor: '#fff',
        borderColor: '#C91F3B',
        textStyle: { fontFamily: 'Cairo', fontSize: 11 }
      },
      legend: {
        bottom: '8%',
        textStyle: { fontFamily: 'Cairo', fontSize: 10 },
        itemGap: 15
      },
      series: [
        {
          type: 'pie',
          radius: ['40%', '70%'],
          data: [
            { value: 45, name: categories[0], itemStyle: { color: '#10b981' } },
            { value: 30, name: categories[1], itemStyle: { color: '#C91F3B' } },
            { value: 18, name: categories[2], itemStyle: { color: '#f59e0b' } },
            { value: 7, name: categories[3], itemStyle: { color: '#ef4444' } }
          ],
          label: {
            show: true,
            formatter: '{d}%',
            fontFamily: 'Cairo',
            fontSize: 11,
            fontWeight: 'bold'
          }
        }
      ]
    };
  }
  
  // Generate Pillar Coverage Chart
  generatePillarCoverageChart() {
    const pillars = this.dir === 'rtl'
      ? ['المحور المالي', 'محور العملاء', 'العمليات الداخلية', 'التعلم والنمو']
      : ['Financial', 'Customer', 'Internal Processes', 'Learning & Growth'];
    
    this.pillarCoverageChartOptions = {
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        backgroundColor: '#fff',
        borderColor: '#C91F3B',
        textStyle: { fontFamily: 'Cairo', fontSize: 11 }
      },
      grid: { left: '3%', right: '4%', bottom: '10%', top: '10%', containLabel: true },
      xAxis: {
        type: 'value',
        max: 100,
        axisLabel: { formatter: '{value}%', fontFamily: 'Cairo', fontSize: 9 }
      },
      yAxis: {
        type: 'category',
        data: pillars,
        axisLabel: { fontFamily: 'Cairo', fontSize: 9 }
      },
      series: [
        {
          type: 'bar',
          data: [92, 85, 88, 80],
          barWidth: '50%',
          itemStyle: { 
            color: '#C91F3B',
            borderRadius: this.dir === 'rtl' ? [0, 8, 8, 0] : [8, 0, 0, 8]
          }
        }
      ]
    };
  }

  // Update chart methods for API data integration
  updateDepartmentTrendChart(apiData: any) {
    console.log('📊 Updating department trend chart with API data:', apiData);
    
    // If API provides trend data, use it
    if (apiData && apiData.months && apiData.series) {
      this.departmentTrendChartOptions.xAxis.data = apiData.months;
      this.departmentTrendChartOptions.series = apiData.series.map((s: any) => ({
        ...s,
        itemStyle: { color: '#C91F3B' }
      }));
      console.log('✅ Trend chart updated with API data');
    } else {
      // If API doesn't provide specific trend chart data, regenerate from departments
      console.log('📊 No specific trend data from API, regenerating chart');
      this.generateDepartmentTrendChart();
    }
  }
  
  updateDepartmentWorkloadChart(apiData: any) {
    if (apiData.data && Array.isArray(apiData.data)) {
      this.departmentWorkloadChartOptions.series[0].data = apiData.data;
      console.log('✅ Workload chart updated with API data');
      this.cdr.detectChanges();
    }
  }
  
  // Calculate budget distribution from actual projects
  calculateBudgetDistribution() {
    if (!this.projects || this.projects.length === 0) {
      return {
        categories: {
          ar: ['غير محدد'],
          en: ['Not Specified']
        },
        values: [0]
      };
    }

    // Group projects by department and sum their budgets
    const budgetByDept: { [key: string]: number } = {};
    
    this.projects.forEach(project => {
      const deptName = project.department_name || 'غير محدد';
      // Budget is in projectResource object
      const budget = (project as any).projectResource?.estimated_budget || 0;
      
      if (!budgetByDept[deptName]) {
        budgetByDept[deptName] = 0;
      }
      budgetByDept[deptName] += budget;
    });

    // Sort by budget descending and take top 5
    const sortedDepts = Object.entries(budgetByDept)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5);

    // If no budgets, return generic categories
    if (sortedDepts.length === 0 || sortedDepts.every(d => d[1] === 0)) {
      return {
        categories: {
          ar: ['لا توجد بيانات'],
          en: ['No Data']
        },
        values: [0]
      };
    }

    return {
      categories: {
        ar: sortedDepts.map(d => d[0]),
        en: sortedDepts.map(d => d[0])
      },
      values: sortedDepts.map(d => Math.round(d[1] / 1000)) // Convert to K
    };
  }

  // Calculate project stages from actual projects
  calculateProjectStages() {
    if (!this.projects || this.projects.length === 0) {
      return {
        stages: {
          ar: ['مكتملة', 'في المرحلة النهائية', 'قيد التنفيذ', 'لم تبدأ'],
          en: ['Completed', 'Final Stage', 'In Progress', 'Not Started']
        },
        values: [0, 0, 0, 0]
      };
    }

    const completed = this.projects.filter(p => p.progress_percentage === 100).length;
    const finalStage = this.projects.filter(p => p.progress_percentage >= 75 && p.progress_percentage < 100).length;
    const inProgress = this.projects.filter(p => p.progress_percentage > 0 && p.progress_percentage < 75).length;
    const notStarted = this.projects.filter(p => p.progress_percentage === 0).length;

    return {
      stages: {
        ar: ['مكتملة', 'في المرحلة النهائية', 'قيد التنفيذ', 'لم تبدأ'],
        en: ['Completed', 'Final Stage', 'In Progress', 'Not Started']
      },
      values: [completed, finalStage, inProgress, notStarted]
    };
  }

  updateProjectTimelineChart(apiData: any) {
    console.log('📊 Updating timeline chart with API data:', apiData);
    
    // Support both PascalCase and camelCase from API
    const quarters = apiData?.Quarters || apiData?.quarters;
    const series = apiData?.Series || apiData?.series;

    if (quarters && series) {
      // Use API data
      
      // Map series from API
      const seriesData = series.map((serie: any) => ({
        name: serie.Name ?? serie.name,
        type: 'bar',
        stack: 'total',
        data: serie.Data ?? serie.data,
        itemStyle: { 
          color: (serie.Name ?? serie.name) === 'Planned' ? '#A71932' : '#C91F3B'
        }
      }));
      
      this.projectTimelineChartOptions = {
        ...this.projectTimelineChartOptions,
        xAxis: {
          ...this.projectTimelineChartOptions.xAxis,
          data: quarters
        },
        series: seriesData
      };
      
      console.log('✅ Timeline chart updated:', this.projectTimelineChartOptions);
      this.cdr.detectChanges();
    }
  }
  
  updateProjectBudgetChart(apiData: any) {
    if (apiData.categories && apiData.data) {
      this.projectBudgetChartOptions.xAxis.data = apiData.categories;
      this.projectBudgetChartOptions.series[0].data = apiData.data;
    }
  }
  
  updateProjectFunnelChart(apiData: any) {
    if (apiData.stages && apiData.data) {
      this.projectFunnelChartOptions.yAxis.data = apiData.stages;
      const colors = ['#10b981', '#C91F3B', '#E0455C', '#e5e7eb'];
      this.projectFunnelChartOptions.series[0].data = apiData.data.map((value: number, index: number) => ({
        value,
        itemStyle: { 
          color: colors[index % colors.length],
          borderRadius: this.dir === 'rtl' ? [8, 0, 0, 8] : [0, 8, 8, 0]
        }
      }));
    } else if (apiData.data && Array.isArray(apiData.data)) {
      // Fallback for simple data array
      const colors = ['#10b981', '#C91F3B', '#E0455C', '#e5e7eb'];
      this.projectFunnelChartOptions.series[0].data = apiData.data.map((value: number, index: number) => ({
        value,
        itemStyle: { 
          color: colors[index % colors.length],
          borderRadius: this.dir === 'rtl' ? [8, 0, 0, 8] : [0, 8, 8, 0]
        }
      }));
    }
    console.log('📊 Project Funnel Chart updated with API data:', apiData);
  }
  
  updateRiskChart(apiData: any) {
    if (apiData.data && Array.isArray(apiData.data)) {
      this.riskChartOptions.series[0].data = apiData.data;
    }
  }
  
  updateCompetitiveChart(apiData: any) {
    if (apiData.indicator && apiData.data) {
      this.competitiveChartOptions.radar.indicator = apiData.indicator;
      this.competitiveChartOptions.series[0].data = apiData.data;
    }
  }
  
  updateRiskMitigationChart(apiData: any) {
    if (apiData.months && apiData.series) {
      this.riskMitigationChartOptions.xAxis.data = apiData.months;
      this.riskMitigationChartOptions.series = apiData.series;
    }
  }
  
  updateImpactTrendChart(apiData: any) {
    if (apiData.months && apiData.data) {
      this.impactTrendChartOptions.xAxis.data = apiData.months;
      this.impactTrendChartOptions.series[0].data = apiData.data;
    }
  }
  
  updateGoalsAchievementChart(apiData: any) {
    if (apiData.goals && apiData.data) {
      this.goalsAchievementChartOptions.xAxis.data = apiData.goals;
      this.goalsAchievementChartOptions.series[0].data = apiData.data;
    }
  }
  
  updateIndicatorDistributionChart(apiData: any) {
    if (apiData.data && Array.isArray(apiData.data)) {
      this.indicatorDistributionChartOptions.series[0].data = apiData.data;
    }
  }
  
  updatePillarCoverageChart(apiData: any) {
    if (apiData.pillars && apiData.data) {
      this.pillarCoverageChartOptions.yAxis.data = apiData.pillars;
      this.pillarCoverageChartOptions.series[0].data = apiData.data;
    }
  }
  
  updateIndicatorsProgressChart(apiData: any) {
    if (apiData.months && apiData.data) {
      this.indicatorsProgressChartOptions.xAxis.data = apiData.months;
      this.indicatorsProgressChartOptions.series[0].data = apiData.data;
    }
  }

  ngOnDestroy(): void {
    // Reset sidebar to expanded state when leaving dashboard
    this.sidebarExpanderService.setDynamic(false);
  }
  
  // Normalize Font Awesome icon classes (ensure prefix comes first)
  normalizeIconClasses(iconClass: string): string {
    if (!iconClass) return '';
    
    const classes = iconClass.trim().split(/\s+/);
    const prefixes = ['fa-solid', 'fa-regular', 'fa-light', 'fa-thin', 'fa-duotone', 'fa-brands', 'fas', 'far', 'fal', 'fat', 'fad', 'fab'];
    
    let prefix = '';
    let iconName = '';
    
    // Find prefix and icon name
    classes.forEach(cls => {
      if (prefixes.includes(cls)) {
        prefix = cls;
      } else if (cls.startsWith('fa-')) {
        iconName = cls;
      }
    });
    
    // If no prefix found, default to fa-solid
    if (!prefix && iconName) {
      prefix = 'fa-solid';
    }
    
    // Return in correct order: prefix first, then icon name
    return prefix && iconName ? `${prefix} ${iconName}` : iconClass;
  }
  
  // Map English labels from API to translation keys
  mapLabelToTranslationKey(label: string): string {
    if (!label) return '';
    
    // Create mapping from English text to translation keys
    const labelMap: { [key: string]: string } = {
      // Department Performance KPIs
      'Total Departments': 'total_departments',
      'Average Completion': 'average_completion',
      'Excellent Departments': 'excellent_departments',
      'Need Improvement': 'need_improvement',
      'إجمالي الإدارات': 'total_departments',
      'متوسط الإنجاز': 'average_completion',
      'إدارات متفوقة': 'excellent_departments',
      'تحتاج تحسين': 'need_improvement',
      
      // Project KPIs
      'Active Projects': 'active_projects',
      'Completed Projects': 'completed_projects',
      'Average Progress': 'average_progress',
      'Total Budget': 'total_budget',
      'المشاريع النشطة': 'active_projects',
      'المشاريع المكتملة': 'completed_projects',
      'متوسط التقدم': 'average_progress',
      'إجمالي الميزانية': 'total_budget',
      
      // Impact KPIs
      'Critical Risks': 'critical_risks',
      'Managed Risks': 'managed_risks',
      'Competitive Index': 'competitive_index',
      'Impact Rate': 'impact_rate',
      'المخاطر الحرجة': 'critical_risks',
      'المخاطر المُدارة': 'managed_risks',
      'المؤشر التنافسي': 'competitive_index',
      'نسبة التأثير': 'impact_rate',
      
      // Environmental KPIs
      'Goals Achieved': 'goals_achieved',
      'Environmental Indicators': 'environmental_indicators',
      'Achievement Rate': 'achievement_rate',
      'Sustainability': 'sustainability',
      'الأهداف المحققة': 'goals_achieved',
      'المؤشرات البيئية': 'environmental_indicators',
      'نسبة الإنجاز': 'achievement_rate',
      'الاستدامة': 'sustainability'
    };
    
    // If it's already a translation key (lowercase with underscores), return it
    if (label.includes('_') && label === label.toLowerCase()) {
      return label;
    }
    
    // Otherwise, try to map it
    return labelMap[label] || label;
  }
  
  // Open chart in modal
  openChartModal(chartOptions: any, titleKey: string) {
    // Create a deep copy of the chart options to modify for modal
    const modalChartOptions = JSON.parse(JSON.stringify(chartOptions));
    
    // Enhance chart options for modal display
    if (modalChartOptions.xAxis) {
      // Make x-axis labels larger, black, and show full text
      if (modalChartOptions.xAxis.axisLabel) {
        modalChartOptions.xAxis.axisLabel.fontSize = 14;
        modalChartOptions.xAxis.axisLabel.color = '#000000';
        modalChartOptions.xAxis.axisLabel.fontWeight = '600';
        // Remove truncation formatter - show full text
        if (modalChartOptions.xAxis.axisLabel.formatter) {
          modalChartOptions.xAxis.axisLabel.formatter = (value: string) => value;
        }
      }
      
      // If xAxis is an array (multiple axes)
      if (Array.isArray(modalChartOptions.xAxis)) {
        modalChartOptions.xAxis.forEach((axis: any) => {
          if (axis.axisLabel) {
            axis.axisLabel.fontSize = 14;
            axis.axisLabel.color = '#000000';
            axis.axisLabel.fontWeight = '600';
            if (axis.axisLabel.formatter) {
              axis.axisLabel.formatter = (value: string) => value;
            }
          }
        });
      }
    }
    
    // Enhance y-axis labels
    if (modalChartOptions.yAxis) {
      if (modalChartOptions.yAxis.axisLabel) {
        modalChartOptions.yAxis.axisLabel.fontSize = 12;
        modalChartOptions.yAxis.axisLabel.color = '#000000';
        modalChartOptions.yAxis.axisLabel.fontWeight = '500';
      }
      
      // If yAxis is an array
      if (Array.isArray(modalChartOptions.yAxis)) {
        modalChartOptions.yAxis.forEach((axis: any) => {
          if (axis.axisLabel) {
            axis.axisLabel.fontSize = 12;
            axis.axisLabel.color = '#000000';
            axis.axisLabel.fontWeight = '500';
          }
        });
      }
    }
    
    // Enhance series labels
    if (modalChartOptions.series && Array.isArray(modalChartOptions.series)) {
      modalChartOptions.series.forEach((series: any) => {
        if (series.label) {
          series.label.fontSize = 13;
          series.label.fontWeight = 'bold';
          series.label.color = '#000000';
        }
        
        // Enhance data labels if they exist
        if (series.data && Array.isArray(series.data)) {
          series.data.forEach((dataItem: any) => {
            if (dataItem && typeof dataItem === 'object' && dataItem.label) {
              dataItem.label.fontSize = 13;
              dataItem.label.fontWeight = 'bold';
            }
          });
        }
      });
    }
    
    // Enhance legend
    if (modalChartOptions.legend && modalChartOptions.legend.textStyle) {
      modalChartOptions.legend.textStyle.fontSize = 14;
      modalChartOptions.legend.textStyle.color = '#000000';
      modalChartOptions.legend.textStyle.fontWeight = '600';
    }
    
    // Adjust grid to accommodate longer labels
    if (modalChartOptions.grid) {
      modalChartOptions.grid.left = '12%';
      modalChartOptions.grid.right = '8%';
      modalChartOptions.grid.bottom = '20%'; // More space for rotated x-axis labels
      modalChartOptions.grid.top = '10%';
      modalChartOptions.grid.containLabel = true;
    }
    
    this.chartModalOptions = modalChartOptions;
    
    // Translate the title key to get the actual translated text
    this.translateService.get(titleKey).subscribe((translatedTitle: string) => {
      this.chartModalTitle = translatedTitle;
    });
    this.chartModalVisible = true;
  }
  
  // Close chart modal
  closeChartModal() {
    this.chartModalVisible = false;
    this.chartModalOptions = null;
    this.chartModalTitle = '';
  }
  
  // TrackBy function for KPI cards to prevent unnecessary re-renders
  trackByKpiLabel(index: number, kpi: any): string {
    return kpi.label || index.toString();
  }
  
  // Parse KPI value to extract numeric value for count-up animation
  parseKpiValue(value: any): number {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
      // Extract the first number from string (handles "75%", "12/15", "8.5/10", etc.)
      const match = value.match(/[\d.]+/);
      if (match) {
        const parsed = parseFloat(match[0]);
        return isNaN(parsed) ? 0 : Math.floor(parsed); // Return integer for counting
      }
    }
    return 0;
  }
  
  // Get suffix from KPI value (%, /10, M, etc.)
  getKpiSuffix(value: any): string {
    if (typeof value === 'number') return '';
    if (typeof value === 'string') {
      // Remove the first number and return the rest
      const suffix = value.replace(/^[\d.]+/, '');
      return suffix;
    }
    return '';
  }
};